/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AdvanceInvoiceNumberRequest } from '../models/advance-invoice-number-request';
import { ClientType } from '../models/client-type';
import { CreateOutgoingPaymentRequest } from '../models/create-outgoing-payment-request';
import { CreateTextMessageRequest } from '../models/create-text-message-request';
import { EInvoiceSend } from '../models/e-invoice-send';
import { FileUrl } from '../models/file-url';
import { GenerateInvoiceAcceptedResult } from '../models/generate-invoice-accepted-result';
import { GenerateOfferAcceptedResult } from '../models/generate-offer-accepted-result';
import { GenerateOfferRequestBody } from '../models/generate-offer-request-body';
import { Invoice } from '../models/invoice';
import { InvoiceAttachment } from '../models/invoice-attachment';
import { InvoiceAttachmentType } from '../models/invoice-attachment-type';
import { InvoiceChecklist } from '../models/invoice-checklist';
import { InvoiceConfiguration } from '../models/invoice-configuration';
import { InvoiceExtractionOrigin } from '../models/invoice-extraction-origin';
import { InvoiceState } from '../models/invoice-state';
import { InvoiceWorkflowEvent } from '../models/invoice-workflow-event';
import { InvoicesResponsePage } from '../models/invoices-response-page';
import { OutgoingPayment } from '../models/outgoing-payment';
import { PaymentHistoriesResponsePage } from '../models/payment-histories-response-page';
import { PcrReportingTask } from '../models/pcr-reporting-task';
import { ReplaceInvoiceFinancesRequest } from '../models/replace-invoice-finances-request';
import { ReplaceInvoiceInformationRequest } from '../models/replace-invoice-information-request';
import { SendInvoiceAcceptedResult } from '../models/send-invoice-accepted-result';
import { SendInvoiceRequestBody } from '../models/send-invoice-request-body';
import { SendSubfinancingInvoiceRequestBody } from '../models/send-subfinancing-invoice-request-body';
import { SetInterestEndDateOverrideRequest } from '../models/set-interest-end-date-override-request';
import { TextMessage } from '../models/text-message';
import { TransferInvoicePreview } from '../models/transfer-invoice-preview';
import { UpdateInvoiceAttachmentRequest } from '../models/update-invoice-attachment-request';
import { UpdateInvoiceClientRepresentativeRequest } from '../models/update-invoice-client-representative-request';
import { UpdateInvoiceEndCustomerContactRequest } from '../models/update-invoice-end-customer-contact-request';
import { WatermarkResponse } from '../models/watermark-response';
import { WatermarkStatus } from '../models/watermark-status';


/**
 * Invoices API
 */
@Injectable({
  providedIn: 'root',
})
export class InvoicesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation listInvoices
   */
  static readonly ListInvoicesPath = '/invoices';

  /**
   * List invoices.
   *
   * List invoices
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listInvoices()` instead.
   *
   * This method doesn't expect any request body.
   */
  listInvoices$Response(params?: {

    /**
     * Search Query.
     */
    'q'?: string;

    /**
     * InvoiceConfiguration ids to include, all if omitted or blank.
     * Comma-separated list of integer primary keys (the
     * &#x60;InvoiceConfiguration.id&#x60; field, not the human-readable name).
     */
    configurations?: Array<number>;

    /**
     * Invoice States to include, all if omitted or blank
     */
    states?: Array<string>;

    /**
     * Client types to include, all if omitted or blank.
     */
    client_types?: Array<ClientType>;

    /**
     * Limit amount of returned results
     */
    limit?: number;

    /**
     * Cursor for the next page of results
     */
    after?: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<InvoicesResponsePage>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.ListInvoicesPath, 'get');
    if (params) {
      rb.query('q', params['q'], {});
      rb.query('configurations', params.configurations, {"style":"form","explode":false});
      rb.query('states', params.states, {"style":"form","explode":false});
      rb.query('client_types', params.client_types, {"style":"form","explode":false});
      rb.query('limit', params.limit, {});
      rb.query('after', params.after, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InvoicesResponsePage>;
      })
    );
  }

  /**
   * List invoices.
   *
   * List invoices
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `listInvoices$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listInvoices(params?: {

    /**
     * Search Query.
     */
    'q'?: string;

    /**
     * InvoiceConfiguration ids to include, all if omitted or blank.
     * Comma-separated list of integer primary keys (the
     * &#x60;InvoiceConfiguration.id&#x60; field, not the human-readable name).
     */
    configurations?: Array<number>;

    /**
     * Invoice States to include, all if omitted or blank
     */
    states?: Array<string>;

    /**
     * Client types to include, all if omitted or blank.
     */
    client_types?: Array<ClientType>;

    /**
     * Limit amount of returned results
     */
    limit?: number;

    /**
     * Cursor for the next page of results
     */
    after?: string;
    context?: HttpContext
  }
): Observable<InvoicesResponsePage> {

    return this.listInvoices$Response(params).pipe(
      map((r: StrictHttpResponse<InvoicesResponsePage>) => r.body as InvoicesResponsePage)
    );
  }

  /**
   * Path part for operation getInvoice
   */
  static readonly GetInvoicePath = '/invoices/{id}';

  /**
   * Get invoice.
   *
   * Get invoice
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInvoice()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInvoice$Response(params: {
    id: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Invoice>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.GetInvoicePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Invoice>;
      })
    );
  }

  /**
   * Get invoice.
   *
   * Get invoice
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getInvoice$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInvoice(params: {
    id: number;
    context?: HttpContext
  }
): Observable<Invoice> {

    return this.getInvoice$Response(params).pipe(
      map((r: StrictHttpResponse<Invoice>) => r.body as Invoice)
    );
  }

  /**
   * Path part for operation getInvoiceChecklist
   */
  static readonly GetInvoiceChecklistPath = '/invoices/{id}/checklist';

  /**
   * Get invoice checklist.
   *
   * Returns the readiness checklist evaluated for the invoice's current workflow state. The checklist is advisory: `missing` items never block an Accept, Reject or Reset workflow event. A state with no defined items yields an empty item list.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInvoiceChecklist()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInvoiceChecklist$Response(params: {
    id: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<InvoiceChecklist>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.GetInvoiceChecklistPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InvoiceChecklist>;
      })
    );
  }

  /**
   * Get invoice checklist.
   *
   * Returns the readiness checklist evaluated for the invoice's current workflow state. The checklist is advisory: `missing` items never block an Accept, Reject or Reset workflow event. A state with no defined items yields an empty item list.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getInvoiceChecklist$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInvoiceChecklist(params: {
    id: number;
    context?: HttpContext
  }
): Observable<InvoiceChecklist> {

    return this.getInvoiceChecklist$Response(params).pipe(
      map((r: StrictHttpResponse<InvoiceChecklist>) => r.body as InvoiceChecklist)
    );
  }

  /**
   * Path part for operation createWorkflowEvent
   */
  static readonly CreateWorkflowEventPath = '/invoices/{id}/workflow/event';

  /**
   * Create Invoice Workflow Event.
   *
   * Fires a workflow event on the invoice.
   *
   * Each event has its own permission, checked before anything changes
   * (403 otherwise):
   *
   * - `accept` and `reject` require `invoice:advance`;
   * - `reset` requires `invoice:reset`.
   *
   * Transitions the system fires itself (the automatic advance after an
   * end customer's full payment, the approval links) do not pass
   * through this endpoint and need no permission.
   *
   * `error_code` values returned with `422`:
   *
   * - `financing_on_hold` — the event is `accept`, the invoice is in
   *   `WaitingForFinancing` or `WaitingFinalPayment`, and at least one
   *   active financing hold applies to it. Nothing changes: no state
   *   change, no state-log row, no `financed_date`. `details.holds` is
   *   an array of `FinancingHold`: the active holds that apply, the
   *   same list as the invoice's `financing_holds`. Release the holds
   *   (`POST /financing-holds/{id}/release`) to accept. `reject` and
   *   `reset` are never refused by a hold.
   *
   * Other `422`s carry no `error_code`: for example the fields the PCR
   * new-loan report is missing (`errors[]`), or a `reset` without a
   * `reason`.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createWorkflowEvent()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createWorkflowEvent$Response(params: {

    /**
     * etag from the Invoice object
     */
    'If-Match'?: string;
    id: number;
    context?: HttpContext
    body: InvoiceWorkflowEvent
  }
): Observable<StrictHttpResponse<Invoice>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.CreateWorkflowEventPath, 'put');
    if (params) {
      rb.header('If-Match', params['If-Match'], {});
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Invoice>;
      })
    );
  }

  /**
   * Create Invoice Workflow Event.
   *
   * Fires a workflow event on the invoice.
   *
   * Each event has its own permission, checked before anything changes
   * (403 otherwise):
   *
   * - `accept` and `reject` require `invoice:advance`;
   * - `reset` requires `invoice:reset`.
   *
   * Transitions the system fires itself (the automatic advance after an
   * end customer's full payment, the approval links) do not pass
   * through this endpoint and need no permission.
   *
   * `error_code` values returned with `422`:
   *
   * - `financing_on_hold` — the event is `accept`, the invoice is in
   *   `WaitingForFinancing` or `WaitingFinalPayment`, and at least one
   *   active financing hold applies to it. Nothing changes: no state
   *   change, no state-log row, no `financed_date`. `details.holds` is
   *   an array of `FinancingHold`: the active holds that apply, the
   *   same list as the invoice's `financing_holds`. Release the holds
   *   (`POST /financing-holds/{id}/release`) to accept. `reject` and
   *   `reset` are never refused by a hold.
   *
   * Other `422`s carry no `error_code`: for example the fields the PCR
   * new-loan report is missing (`errors[]`), or a `reset` without a
   * `reason`.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createWorkflowEvent$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createWorkflowEvent(params: {

    /**
     * etag from the Invoice object
     */
    'If-Match'?: string;
    id: number;
    context?: HttpContext
    body: InvoiceWorkflowEvent
  }
): Observable<Invoice> {

    return this.createWorkflowEvent$Response(params).pipe(
      map((r: StrictHttpResponse<Invoice>) => r.body as Invoice)
    );
  }

  /**
   * Path part for operation listTextMessages
   */
  static readonly ListTextMessagesPath = '/invoices/{id}/text-messages';

  /**
   * List text messages for an invoice.
   *
   * List text messages for an invoice
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listTextMessages()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTextMessages$Response(params: {
    id: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<TextMessage>>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.ListTextMessagesPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TextMessage>>;
      })
    );
  }

  /**
   * List text messages for an invoice.
   *
   * List text messages for an invoice
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `listTextMessages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTextMessages(params: {
    id: number;
    context?: HttpContext
  }
): Observable<Array<TextMessage>> {

    return this.listTextMessages$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TextMessage>>) => r.body as Array<TextMessage>)
    );
  }

  /**
   * Path part for operation createTextMessage
   */
  static readonly CreateTextMessagePath = '/invoices/{id}/text-messages';

  /**
   * Send a text message for an invoice.
   *
   * Send a text message for an invoice
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTextMessage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTextMessage$Response(params: {
    id: number;
    context?: HttpContext
    body: CreateTextMessageRequest
  }
): Observable<StrictHttpResponse<TextMessage>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.CreateTextMessagePath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TextMessage>;
      })
    );
  }

  /**
   * Send a text message for an invoice.
   *
   * Send a text message for an invoice
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createTextMessage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTextMessage(params: {
    id: number;
    context?: HttpContext
    body: CreateTextMessageRequest
  }
): Observable<TextMessage> {

    return this.createTextMessage$Response(params).pipe(
      map((r: StrictHttpResponse<TextMessage>) => r.body as TextMessage)
    );
  }

  /**
   * Path part for operation listEInvoiceSends
   */
  static readonly ListEInvoiceSendsPath = '/invoices/{id}/einvoice-sends';

  /**
   * List Apix eInvoice send attempts for an invoice.
   *
   * Returns every recorded Apix transmission attempt for the invoice, newest first — the send log behind the invoice Activity page. A run that failed before the record step (data fetch, document regeneration, image build, package build) leaves no row, so the absence of a row means nothing was transmitted. Attempts recorded before the transmission facts were captured carry `null` in the receiver, transmitted-number, user, override and message-timestamp fields; they are never backfilled.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listEInvoiceSends()` instead.
   *
   * This method doesn't expect any request body.
   */
  listEInvoiceSends$Response(params: {
    id: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<EInvoiceSend>>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.ListEInvoiceSendsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<EInvoiceSend>>;
      })
    );
  }

  /**
   * List Apix eInvoice send attempts for an invoice.
   *
   * Returns every recorded Apix transmission attempt for the invoice, newest first — the send log behind the invoice Activity page. A run that failed before the record step (data fetch, document regeneration, image build, package build) leaves no row, so the absence of a row means nothing was transmitted. Attempts recorded before the transmission facts were captured carry `null` in the receiver, transmitted-number, user, override and message-timestamp fields; they are never backfilled.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `listEInvoiceSends$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listEInvoiceSends(params: {
    id: number;
    context?: HttpContext
  }
): Observable<Array<EInvoiceSend>> {

    return this.listEInvoiceSends$Response(params).pipe(
      map((r: StrictHttpResponse<Array<EInvoiceSend>>) => r.body as Array<EInvoiceSend>)
    );
  }

  /**
   * Path part for operation getInvoiceExtractionOrigin
   */
  static readonly GetInvoiceExtractionOriginPath = '/invoices/{invoiceID}/extraction';

  /**
   * Whether an invoice was created from an extraction.
   *
   * The extraction that created the invoice, when it was created by
   * submitting one (issue #424), and the invoice's Extracted Finvoice
   * attachments: the Finvoice built from the values the sales agent
   * submitted, never the client's Original Finvoice. An invoice created
   * any other way answers a null `extraction_id` and no attachments.
   * Gated, like the invoice's other reads, on authentication alone: the
   * extraction itself needs `invoices:extract`.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInvoiceExtractionOrigin()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInvoiceExtractionOrigin$Response(params: {
    invoiceID: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<InvoiceExtractionOrigin>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.GetInvoiceExtractionOriginPath, 'get');
    if (params) {
      rb.path('invoiceID', params.invoiceID, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InvoiceExtractionOrigin>;
      })
    );
  }

  /**
   * Whether an invoice was created from an extraction.
   *
   * The extraction that created the invoice, when it was created by
   * submitting one (issue #424), and the invoice's Extracted Finvoice
   * attachments: the Finvoice built from the values the sales agent
   * submitted, never the client's Original Finvoice. An invoice created
   * any other way answers a null `extraction_id` and no attachments.
   * Gated, like the invoice's other reads, on authentication alone: the
   * extraction itself needs `invoices:extract`.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getInvoiceExtractionOrigin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInvoiceExtractionOrigin(params: {
    invoiceID: number;
    context?: HttpContext
  }
): Observable<InvoiceExtractionOrigin> {

    return this.getInvoiceExtractionOrigin$Response(params).pipe(
      map((r: StrictHttpResponse<InvoiceExtractionOrigin>) => r.body as InvoiceExtractionOrigin)
    );
  }

  /**
   * Path part for operation listInvoiceAttachments
   */
  static readonly ListInvoiceAttachmentsPath = '/invoices/{invoiceID}/attachments';

  /**
   * List attachments for an invoice.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listInvoiceAttachments()` instead.
   *
   * This method doesn't expect any request body.
   */
  listInvoiceAttachments$Response(params: {
    invoiceID: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<InvoiceAttachment>>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.ListInvoiceAttachmentsPath, 'get');
    if (params) {
      rb.path('invoiceID', params.invoiceID, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<InvoiceAttachment>>;
      })
    );
  }

  /**
   * List attachments for an invoice.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `listInvoiceAttachments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listInvoiceAttachments(params: {
    invoiceID: number;
    context?: HttpContext
  }
): Observable<Array<InvoiceAttachment>> {

    return this.listInvoiceAttachments$Response(params).pipe(
      map((r: StrictHttpResponse<Array<InvoiceAttachment>>) => r.body as Array<InvoiceAttachment>)
    );
  }

  /**
   * Path part for operation uploadInvoiceAttachment
   */
  static readonly UploadInvoiceAttachmentPath = '/invoices/{invoiceID}/attachments';

  /**
   * Upload a new attachment to an invoice.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadInvoiceAttachment()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadInvoiceAttachment$Response(params: {
    invoiceID: number;
    context?: HttpContext
    body: {

/**
 * The file to upload.
 */
'file': Blob;

/**
 * Optional user-provided description.
 */
'description'?: string;

/**
 * FK to InvoiceAttachmentTypes.
 */
'attachment_type_id': number;
}
  }
): Observable<StrictHttpResponse<InvoiceAttachment>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.UploadInvoiceAttachmentPath, 'post');
    if (params) {
      rb.path('invoiceID', params.invoiceID, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InvoiceAttachment>;
      })
    );
  }

  /**
   * Upload a new attachment to an invoice.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `uploadInvoiceAttachment$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadInvoiceAttachment(params: {
    invoiceID: number;
    context?: HttpContext
    body: {

/**
 * The file to upload.
 */
'file': Blob;

/**
 * Optional user-provided description.
 */
'description'?: string;

/**
 * FK to InvoiceAttachmentTypes.
 */
'attachment_type_id': number;
}
  }
): Observable<InvoiceAttachment> {

    return this.uploadInvoiceAttachment$Response(params).pipe(
      map((r: StrictHttpResponse<InvoiceAttachment>) => r.body as InvoiceAttachment)
    );
  }

  /**
   * Path part for operation updateInvoiceAttachment
   */
  static readonly UpdateInvoiceAttachmentPath = '/invoices/{invoiceID}/attachments/{attachmentID}';

  /**
   * Update attachment metadata.
   *
   * Updates metadata fields on an invoice attachment. Only provided fields are updated (PATCH semantics). File content and invoice association cannot be changed.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateInvoiceAttachment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateInvoiceAttachment$Response(params: {
    invoiceID: number;
    attachmentID: number;
    context?: HttpContext
    body: UpdateInvoiceAttachmentRequest
  }
): Observable<StrictHttpResponse<InvoiceAttachment>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.UpdateInvoiceAttachmentPath, 'patch');
    if (params) {
      rb.path('invoiceID', params.invoiceID, {});
      rb.path('attachmentID', params.attachmentID, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InvoiceAttachment>;
      })
    );
  }

  /**
   * Update attachment metadata.
   *
   * Updates metadata fields on an invoice attachment. Only provided fields are updated (PATCH semantics). File content and invoice association cannot be changed.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateInvoiceAttachment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateInvoiceAttachment(params: {
    invoiceID: number;
    attachmentID: number;
    context?: HttpContext
    body: UpdateInvoiceAttachmentRequest
  }
): Observable<InvoiceAttachment> {

    return this.updateInvoiceAttachment$Response(params).pipe(
      map((r: StrictHttpResponse<InvoiceAttachment>) => r.body as InvoiceAttachment)
    );
  }

  /**
   * Path part for operation getInvoiceAttachmentFile
   */
  static readonly GetInvoiceAttachmentFilePath = '/invoices/{invoiceID}/attachments/{attachmentID}/file';

  /**
   * Get a download URL for an invoice attachment.
   *
   * Returns a short-lived signed URL that can be used to download the attachment file. The URL expires after 1 minute.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInvoiceAttachmentFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInvoiceAttachmentFile$Response(params: {
    invoiceID: number;
    attachmentID: number;

    /**
     * If true, the Content-Disposition on the signed URL will be &quot;inline&quot; (view in browser). If false, it will be &quot;attachment&quot; (trigger download).
     */
    inline?: boolean;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<FileUrl>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.GetInvoiceAttachmentFilePath, 'get');
    if (params) {
      rb.path('invoiceID', params.invoiceID, {});
      rb.path('attachmentID', params.attachmentID, {});
      rb.query('inline', params.inline, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FileUrl>;
      })
    );
  }

  /**
   * Get a download URL for an invoice attachment.
   *
   * Returns a short-lived signed URL that can be used to download the attachment file. The URL expires after 1 minute.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getInvoiceAttachmentFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInvoiceAttachmentFile(params: {
    invoiceID: number;
    attachmentID: number;

    /**
     * If true, the Content-Disposition on the signed URL will be &quot;inline&quot; (view in browser). If false, it will be &quot;attachment&quot; (trigger download).
     */
    inline?: boolean;
    context?: HttpContext
  }
): Observable<FileUrl> {

    return this.getInvoiceAttachmentFile$Response(params).pipe(
      map((r: StrictHttpResponse<FileUrl>) => r.body as FileUrl)
    );
  }

  /**
   * Path part for operation getWatermarkStatus
   */
  static readonly GetWatermarkStatusPath = '/invoices/{invoiceID}/watermark';

  /**
   * Get watermarking workflow status.
   *
   * Returns the current status of the most recent watermarking workflow for
   * this invoice. Includes per-attachment error details if any files failed.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWatermarkStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWatermarkStatus$Response(params: {
    invoiceID: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<WatermarkStatus>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.GetWatermarkStatusPath, 'get');
    if (params) {
      rb.path('invoiceID', params.invoiceID, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WatermarkStatus>;
      })
    );
  }

  /**
   * Get watermarking workflow status.
   *
   * Returns the current status of the most recent watermarking workflow for
   * this invoice. Includes per-attachment error details if any files failed.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getWatermarkStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWatermarkStatus(params: {
    invoiceID: number;
    context?: HttpContext
  }
): Observable<WatermarkStatus> {

    return this.getWatermarkStatus$Response(params).pipe(
      map((r: StrictHttpResponse<WatermarkStatus>) => r.body as WatermarkStatus)
    );
  }

  /**
   * Path part for operation watermarkInvoiceAttachments
   */
  static readonly WatermarkInvoiceAttachmentsPath = '/invoices/{invoiceID}/watermark';

  /**
   * Watermark original invoice and attachments.
   *
   * Triggers asynchronous watermarking of the Original Invoice and all PDF-type
   * Original Invoice Attachments for the given invoice. Watermarked copies are
   * saved as new attachments of type "WatermarkedOriginalInvoice". Any previously
   * existing watermarked attachments are hidden.
   *
   * This is a fire-and-forget operation. Progress is communicated via SSE
   * notifications (event types: invoice_attachment_created, invoice_attachment_updated).
   *
   * Use GET /invoices/{invoiceID}/watermark to query the workflow status.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `watermarkInvoiceAttachments()` instead.
   *
   * This method doesn't expect any request body.
   */
  watermarkInvoiceAttachments$Response(params: {
    invoiceID: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<WatermarkResponse>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.WatermarkInvoiceAttachmentsPath, 'post');
    if (params) {
      rb.path('invoiceID', params.invoiceID, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WatermarkResponse>;
      })
    );
  }

  /**
   * Watermark original invoice and attachments.
   *
   * Triggers asynchronous watermarking of the Original Invoice and all PDF-type
   * Original Invoice Attachments for the given invoice. Watermarked copies are
   * saved as new attachments of type "WatermarkedOriginalInvoice". Any previously
   * existing watermarked attachments are hidden.
   *
   * This is a fire-and-forget operation. Progress is communicated via SSE
   * notifications (event types: invoice_attachment_created, invoice_attachment_updated).
   *
   * Use GET /invoices/{invoiceID}/watermark to query the workflow status.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `watermarkInvoiceAttachments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  watermarkInvoiceAttachments(params: {
    invoiceID: number;
    context?: HttpContext
  }
): Observable<WatermarkResponse> {

    return this.watermarkInvoiceAttachments$Response(params).pipe(
      map((r: StrictHttpResponse<WatermarkResponse>) => r.body as WatermarkResponse)
    );
  }

  /**
   * Path part for operation listOutgoingPayments
   */
  static readonly ListOutgoingPaymentsPath = '/invoices/{id}/outgoing-payments';

  /**
   * List outgoing payments for an invoice.
   *
   * Lists all outgoing payments associated with an invoice.
   * This includes both new payments and legacy payments from the PaymentTransfers table.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listOutgoingPayments()` instead.
   *
   * This method doesn't expect any request body.
   */
  listOutgoingPayments$Response(params: {
    id: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<OutgoingPayment>>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.ListOutgoingPaymentsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OutgoingPayment>>;
      })
    );
  }

  /**
   * List outgoing payments for an invoice.
   *
   * Lists all outgoing payments associated with an invoice.
   * This includes both new payments and legacy payments from the PaymentTransfers table.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `listOutgoingPayments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listOutgoingPayments(params: {
    id: number;
    context?: HttpContext
  }
): Observable<Array<OutgoingPayment>> {

    return this.listOutgoingPayments$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OutgoingPayment>>) => r.body as Array<OutgoingPayment>)
    );
  }

  /**
   * Path part for operation createOutgoingPayment
   */
  static readonly CreateOutgoingPaymentPath = '/invoices/{id}/outgoing-payments';

  /**
   * Create a new outgoing payment for an invoice.
   *
   * Creates a new outgoing bank payment for a specific invoice.
   * Requires the `payments:create` permission (403 otherwise).
   *
   * `error_code` values returned with `422` include:
   *
   * - `financing_on_hold` — `reason_key` is `INVOICE_FINANCING` or
   *   `FINAL_PAYMENT` and at least one active financing hold applies to
   *   the invoice. No payment is recorded and no bank workflow starts.
   *   The hold is checked before the IBAN and amount verification, so
   *   `allow_amount_override` never bypasses it. `details.holds` is an
   *   array of `FinancingHold`: the active holds that apply, the same
   *   list as the invoice's `financing_holds`. Payments with any other
   *   reason are not checked against holds.
   * - `express_mismatch` — `reason_key` is `INVOICE_FINANCING` and
   *   `is_express` differs from the invoice's `express_payment`: a
   *   financing payout is sent express exactly when the invoice's express
   *   payment is on, since `express_payment_fee` is deducted from
   *   `amount_financed` exactly then. No payment is recorded and no bank
   *   workflow starts. The message tells the caller to change express
   *   payment on the invoice; `details.express_payment` is the invoice's
   *   `express_payment`. `allow_amount_override` does not bypass the
   *   check. Final payments and payments with any other reason are not
   *   checked.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOutgoingPayment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOutgoingPayment$Response(params: {
    id: number;
    context?: HttpContext
    body: CreateOutgoingPaymentRequest
  }
): Observable<StrictHttpResponse<OutgoingPayment>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.CreateOutgoingPaymentPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OutgoingPayment>;
      })
    );
  }

  /**
   * Create a new outgoing payment for an invoice.
   *
   * Creates a new outgoing bank payment for a specific invoice.
   * Requires the `payments:create` permission (403 otherwise).
   *
   * `error_code` values returned with `422` include:
   *
   * - `financing_on_hold` — `reason_key` is `INVOICE_FINANCING` or
   *   `FINAL_PAYMENT` and at least one active financing hold applies to
   *   the invoice. No payment is recorded and no bank workflow starts.
   *   The hold is checked before the IBAN and amount verification, so
   *   `allow_amount_override` never bypasses it. `details.holds` is an
   *   array of `FinancingHold`: the active holds that apply, the same
   *   list as the invoice's `financing_holds`. Payments with any other
   *   reason are not checked against holds.
   * - `express_mismatch` — `reason_key` is `INVOICE_FINANCING` and
   *   `is_express` differs from the invoice's `express_payment`: a
   *   financing payout is sent express exactly when the invoice's express
   *   payment is on, since `express_payment_fee` is deducted from
   *   `amount_financed` exactly then. No payment is recorded and no bank
   *   workflow starts. The message tells the caller to change express
   *   payment on the invoice; `details.express_payment` is the invoice's
   *   `express_payment`. `allow_amount_override` does not bypass the
   *   check. Final payments and payments with any other reason are not
   *   checked.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createOutgoingPayment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOutgoingPayment(params: {
    id: number;
    context?: HttpContext
    body: CreateOutgoingPaymentRequest
  }
): Observable<OutgoingPayment> {

    return this.createOutgoingPayment$Response(params).pipe(
      map((r: StrictHttpResponse<OutgoingPayment>) => r.body as OutgoingPayment)
    );
  }

  /**
   * Path part for operation cancelOutgoingPayment
   */
  static readonly CancelOutgoingPaymentPath = '/invoices/{invoice_id}/outgoing-payments/{payment_id}/cancellations';

  /**
   * Cancel an outgoing payment submission.
   *
   * Sends a signal to cancel an outgoing payment that has not yet been processed by the bank.
   * This is only possible for a short period after creation. This action is not available for legacy payments.
   * Requires the `payments:cancel` permission (403 otherwise).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cancelOutgoingPayment()` instead.
   *
   * This method doesn't expect any request body.
   */
  cancelOutgoingPayment$Response(params: {
    invoice_id: number;
    payment_id: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.CancelOutgoingPaymentPath, 'post');
    if (params) {
      rb.path('invoice_id', params.invoice_id, {});
      rb.path('payment_id', params.payment_id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Cancel an outgoing payment submission.
   *
   * Sends a signal to cancel an outgoing payment that has not yet been processed by the bank.
   * This is only possible for a short period after creation. This action is not available for legacy payments.
   * Requires the `payments:cancel` permission (403 otherwise).
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `cancelOutgoingPayment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cancelOutgoingPayment(params: {
    invoice_id: number;
    payment_id: number;
    context?: HttpContext
  }
): Observable<void> {

    return this.cancelOutgoingPayment$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation retryOutgoingPayment
   */
  static readonly RetryOutgoingPaymentPath = '/invoices/{invoice_id}/outgoing-payments/{payment_id}/retries';

  /**
   * Retry a failed outgoing payment submission.
   *
   * Sends a signal to retry submitting an outgoing payment that previously failed.
   * This action is not available for legacy payments.
   * Requires the `payments:retry` permission (403 otherwise).
   *
   * `error_code` values returned with `422`:
   *
   * - `financing_on_hold` — the payment's reason is
   *   `INVOICE_FINANCING` or `FINAL_PAYMENT` and at least one active
   *   financing hold applies to its invoice. No signal is sent and the
   *   payment's status is unchanged. `details.holds` is an array of
   *   `FinancingHold`: the active holds that apply, the same list as
   *   the invoice's `financing_holds`.
   * - `express_mismatch` — the payment's reason is `INVOICE_FINANCING` and
   *   its `is_express` differs from its invoice's `express_payment`, which
   *   can have changed since the payout was created. No signal is sent and
   *   the payment's status is unchanged. The message and
   *   `details.express_payment` are those of `createOutgoingPayment`'s
   *   `express_mismatch`; to send the payout the way the invoice is priced,
   *   create a new one. Final payments and payments with any other reason
   *   are not checked.
   *
   * A `422` without an `error_code` refuses an express payment whose
   * recipient's bank is not on the express allowlist, as creating it
   * would.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `retryOutgoingPayment()` instead.
   *
   * This method doesn't expect any request body.
   */
  retryOutgoingPayment$Response(params: {
    invoice_id: number;
    payment_id: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.RetryOutgoingPaymentPath, 'post');
    if (params) {
      rb.path('invoice_id', params.invoice_id, {});
      rb.path('payment_id', params.payment_id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Retry a failed outgoing payment submission.
   *
   * Sends a signal to retry submitting an outgoing payment that previously failed.
   * This action is not available for legacy payments.
   * Requires the `payments:retry` permission (403 otherwise).
   *
   * `error_code` values returned with `422`:
   *
   * - `financing_on_hold` — the payment's reason is
   *   `INVOICE_FINANCING` or `FINAL_PAYMENT` and at least one active
   *   financing hold applies to its invoice. No signal is sent and the
   *   payment's status is unchanged. `details.holds` is an array of
   *   `FinancingHold`: the active holds that apply, the same list as
   *   the invoice's `financing_holds`.
   * - `express_mismatch` — the payment's reason is `INVOICE_FINANCING` and
   *   its `is_express` differs from its invoice's `express_payment`, which
   *   can have changed since the payout was created. No signal is sent and
   *   the payment's status is unchanged. The message and
   *   `details.express_payment` are those of `createOutgoingPayment`'s
   *   `express_mismatch`; to send the payout the way the invoice is priced,
   *   create a new one. Final payments and payments with any other reason
   *   are not checked.
   *
   * A `422` without an `error_code` refuses an express payment whose
   * recipient's bank is not on the express allowlist, as creating it
   * would.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `retryOutgoingPayment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  retryOutgoingPayment(params: {
    invoice_id: number;
    payment_id: number;
    context?: HttpContext
  }
): Observable<void> {

    return this.retryOutgoingPayment$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation resubmitOutgoingPayment
   */
  static readonly ResubmitOutgoingPaymentPath = '/invoices/{invoice_id}/outgoing-payments/{payment_id}/resubmissions';

  /**
   * Resubmit an outgoing payment.
   *
   * Reverts a payment from a 'SUBMITTED_TO_BANK' state back to 'PENDING_SUBMISSION' and starts a new submission workflow.
   * This is intended for cases where a payment is stuck and suspected to have not been processed by the bank.
   * This action is not available for legacy payments.
   * Requires the `payments:resubmit` permission (403 otherwise).
   *
   * `error_code` values returned with `422`:
   *
   * - `financing_on_hold` — the payment's reason is
   *   `INVOICE_FINANCING` or `FINAL_PAYMENT` and at least one active
   *   financing hold applies to its invoice. The payment stays in
   *   `SUBMITTED_TO_BANK` and no submission workflow starts.
   *   `details.holds` is an array of `FinancingHold`: the active holds
   *   that apply, the same list as the invoice's `financing_holds`.
   * - `express_mismatch` — the payment's reason is `INVOICE_FINANCING` and
   *   its `is_express` differs from its invoice's `express_payment`, which
   *   can have changed since the payout was created. The payment stays in
   *   `SUBMITTED_TO_BANK` and no submission workflow starts. The message and
   *   `details.express_payment` are those of `createOutgoingPayment`'s
   *   `express_mismatch`; to send the payout the way the invoice is priced,
   *   create a new one. Final payments and payments with any other reason
   *   are not checked.
   *
   * A `422` without an `error_code` refuses an express payment whose
   * recipient's bank is not on the express allowlist, as creating it
   * would.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resubmitOutgoingPayment()` instead.
   *
   * This method doesn't expect any request body.
   */
  resubmitOutgoingPayment$Response(params: {
    invoice_id: number;
    payment_id: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.ResubmitOutgoingPaymentPath, 'post');
    if (params) {
      rb.path('invoice_id', params.invoice_id, {});
      rb.path('payment_id', params.payment_id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Resubmit an outgoing payment.
   *
   * Reverts a payment from a 'SUBMITTED_TO_BANK' state back to 'PENDING_SUBMISSION' and starts a new submission workflow.
   * This is intended for cases where a payment is stuck and suspected to have not been processed by the bank.
   * This action is not available for legacy payments.
   * Requires the `payments:resubmit` permission (403 otherwise).
   *
   * `error_code` values returned with `422`:
   *
   * - `financing_on_hold` — the payment's reason is
   *   `INVOICE_FINANCING` or `FINAL_PAYMENT` and at least one active
   *   financing hold applies to its invoice. The payment stays in
   *   `SUBMITTED_TO_BANK` and no submission workflow starts.
   *   `details.holds` is an array of `FinancingHold`: the active holds
   *   that apply, the same list as the invoice's `financing_holds`.
   * - `express_mismatch` — the payment's reason is `INVOICE_FINANCING` and
   *   its `is_express` differs from its invoice's `express_payment`, which
   *   can have changed since the payout was created. The payment stays in
   *   `SUBMITTED_TO_BANK` and no submission workflow starts. The message and
   *   `details.express_payment` are those of `createOutgoingPayment`'s
   *   `express_mismatch`; to send the payout the way the invoice is priced,
   *   create a new one. Final payments and payments with any other reason
   *   are not checked.
   *
   * A `422` without an `error_code` refuses an express payment whose
   * recipient's bank is not on the express allowlist, as creating it
   * would.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resubmitOutgoingPayment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resubmitOutgoingPayment(params: {
    invoice_id: number;
    payment_id: number;
    context?: HttpContext
  }
): Observable<void> {

    return this.resubmitOutgoingPayment$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation updateInvoiceClientRepresentative
   */
  static readonly UpdateInvoiceClientRepresentativePath = '/invoices/{id}/client-representative';

  /**
   * Set or change the client representative for an invoice.
   *
   * Sets or updates the client representative associated with an invoice. This also implicitly sets the client.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateInvoiceClientRepresentative()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateInvoiceClientRepresentative$Response(params: {
    id: number;
    context?: HttpContext
    body: UpdateInvoiceClientRepresentativeRequest
  }
): Observable<StrictHttpResponse<Invoice>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.UpdateInvoiceClientRepresentativePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Invoice>;
      })
    );
  }

  /**
   * Set or change the client representative for an invoice.
   *
   * Sets or updates the client representative associated with an invoice. This also implicitly sets the client.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateInvoiceClientRepresentative$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateInvoiceClientRepresentative(params: {
    id: number;
    context?: HttpContext
    body: UpdateInvoiceClientRepresentativeRequest
  }
): Observable<Invoice> {

    return this.updateInvoiceClientRepresentative$Response(params).pipe(
      map((r: StrictHttpResponse<Invoice>) => r.body as Invoice)
    );
  }

  /**
   * Path part for operation updateInvoiceEndCustomerContact
   */
  static readonly UpdateInvoiceEndCustomerContactPath = '/invoices/{id}/end-customer-contact';

  /**
   * Set or change the end customer contact for an invoice.
   *
   * Sets or updates the end customer contact associated with an invoice. This also implicitly sets the end customer.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateInvoiceEndCustomerContact()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateInvoiceEndCustomerContact$Response(params: {
    id: number;
    context?: HttpContext
    body: UpdateInvoiceEndCustomerContactRequest
  }
): Observable<StrictHttpResponse<Invoice>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.UpdateInvoiceEndCustomerContactPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Invoice>;
      })
    );
  }

  /**
   * Set or change the end customer contact for an invoice.
   *
   * Sets or updates the end customer contact associated with an invoice. This also implicitly sets the end customer.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateInvoiceEndCustomerContact$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateInvoiceEndCustomerContact(params: {
    id: number;
    context?: HttpContext
    body: UpdateInvoiceEndCustomerContactRequest
  }
): Observable<Invoice> {

    return this.updateInvoiceEndCustomerContact$Response(params).pipe(
      map((r: StrictHttpResponse<Invoice>) => r.body as Invoice)
    );
  }

  /**
   * Path part for operation deleteInvoiceEndCustomerContact
   */
  static readonly DeleteInvoiceEndCustomerContactPath = '/invoices/{id}/end-customer-contact';

  /**
   * Remove the end customer contact from an invoice.
   *
   * Removes the end customer contact association from an invoice, setting it to null. This also removes the end customer association.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteInvoiceEndCustomerContact()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteInvoiceEndCustomerContact$Response(params: {
    id: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Invoice>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.DeleteInvoiceEndCustomerContactPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Invoice>;
      })
    );
  }

  /**
   * Remove the end customer contact from an invoice.
   *
   * Removes the end customer contact association from an invoice, setting it to null. This also removes the end customer association.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteInvoiceEndCustomerContact$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteInvoiceEndCustomerContact(params: {
    id: number;
    context?: HttpContext
  }
): Observable<Invoice> {

    return this.deleteInvoiceEndCustomerContact$Response(params).pipe(
      map((r: StrictHttpResponse<Invoice>) => r.body as Invoice)
    );
  }

  /**
   * Path part for operation listInvoicePcrReportingHistory
   */
  static readonly ListInvoicePcrReportingHistoryPath = '/invoices/{id}/pcr-status';

  /**
   * List PCR reporting history for an invoice.
   *
   * Returns a list of all PCR reporting tasks associated with the invoice.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listInvoicePcrReportingHistory()` instead.
   *
   * This method doesn't expect any request body.
   */
  listInvoicePcrReportingHistory$Response(params: {
    id: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<{
'items': Array<PcrReportingTask>;
}>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.ListInvoicePcrReportingHistoryPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'items': Array<PcrReportingTask>;
        }>;
      })
    );
  }

  /**
   * List PCR reporting history for an invoice.
   *
   * Returns a list of all PCR reporting tasks associated with the invoice.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `listInvoicePcrReportingHistory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listInvoicePcrReportingHistory(params: {
    id: number;
    context?: HttpContext
  }
): Observable<{
'items': Array<PcrReportingTask>;
}> {

    return this.listInvoicePcrReportingHistory$Response(params).pipe(
      map((r: StrictHttpResponse<{
'items': Array<PcrReportingTask>;
}>) => r.body as {
'items': Array<PcrReportingTask>;
})
    );
  }

  /**
   * Path part for operation sendInvoiceToAccounting
   */
  static readonly SendInvoiceToAccountingPath = '/invoices/{id}/send-to-accounting';

  /**
   * Send invoice to accounting.
   *
   * Sends the invoice to the external accounting system (Netvisor).
   * If the invoice has already been sent (ExternalID is present), this operation is idempotent and will return success.
   *
   * `error_code` values returned with `422`:
   *
   * - `netvisor_rejected` — Netvisor explicitly rejected our outbound
   *   payload (HTTP 400 with `ResponseStatus.Status[0] == "FAILED"`),
   *   typically because of invalid end-customer data such as an
   *   unrecognised e-invoice operator. `message` carries the upstream
   *   `Status[1]` string verbatim so the Factoring Handler can act on it.
   *   Other Netvisor failure modes (authentication, transient errors)
   *   continue to surface as `500`.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendInvoiceToAccounting()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendInvoiceToAccounting$Response(params: {
    id: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Invoice>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.SendInvoiceToAccountingPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Invoice>;
      })
    );
  }

  /**
   * Send invoice to accounting.
   *
   * Sends the invoice to the external accounting system (Netvisor).
   * If the invoice has already been sent (ExternalID is present), this operation is idempotent and will return success.
   *
   * `error_code` values returned with `422`:
   *
   * - `netvisor_rejected` — Netvisor explicitly rejected our outbound
   *   payload (HTTP 400 with `ResponseStatus.Status[0] == "FAILED"`),
   *   typically because of invalid end-customer data such as an
   *   unrecognised e-invoice operator. `message` carries the upstream
   *   `Status[1]` string verbatim so the Factoring Handler can act on it.
   *   Other Netvisor failure modes (authentication, transient errors)
   *   continue to surface as `500`.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `sendInvoiceToAccounting$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendInvoiceToAccounting(params: {
    id: number;
    context?: HttpContext
  }
): Observable<Invoice> {

    return this.sendInvoiceToAccounting$Response(params).pipe(
      map((r: StrictHttpResponse<Invoice>) => r.body as Invoice)
    );
  }

  /**
   * Path part for operation recalculateInvoice
   */
  static readonly RecalculateInvoicePath = '/invoices/{id}/recalculate';

  /**
   * Recalculate invoice financial figures.
   *
   * Recalculates derived financial figures for the invoice (financing fee,
   * amount financed, financed days, final payment amount, total profit,
   * penalty interest fee) and persists them. Replaces the legacy
   * `PATCH /apiv2/invoices/{id}/calculate-interests` action.
   *
   * Before running the calculator, `ExpressPaymentFee` is materialized from
   * agreement state: if `ExpressPayment == 2` it is set to
   * `AgreedExpressPaymentFee` (when non-null and > 0) or otherwise to the
   * `ExpressPayment` system setting; if `ExpressPayment == 1` it is forced
   * to `0`. If the system setting is missing for an opted-in invoice, the
   * request fails with `500` rather than silently treating the fee as zero.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `recalculateInvoice()` instead.
   *
   * This method doesn't expect any request body.
   */
  recalculateInvoice$Response(params: {
    id: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Invoice>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.RecalculateInvoicePath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Invoice>;
      })
    );
  }

  /**
   * Recalculate invoice financial figures.
   *
   * Recalculates derived financial figures for the invoice (financing fee,
   * amount financed, financed days, final payment amount, total profit,
   * penalty interest fee) and persists them. Replaces the legacy
   * `PATCH /apiv2/invoices/{id}/calculate-interests` action.
   *
   * Before running the calculator, `ExpressPaymentFee` is materialized from
   * agreement state: if `ExpressPayment == 2` it is set to
   * `AgreedExpressPaymentFee` (when non-null and > 0) or otherwise to the
   * `ExpressPayment` system setting; if `ExpressPayment == 1` it is forced
   * to `0`. If the system setting is missing for an opted-in invoice, the
   * request fails with `500` rather than silently treating the fee as zero.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `recalculateInvoice$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  recalculateInvoice(params: {
    id: number;
    context?: HttpContext
  }
): Observable<Invoice> {

    return this.recalculateInvoice$Response(params).pipe(
      map((r: StrictHttpResponse<Invoice>) => r.body as Invoice)
    );
  }

  /**
   * Path part for operation replaceInvoiceFinances
   */
  static readonly ReplaceInvoiceFinancesPath = '/invoices/{id}/finances';

  /**
   * Replace the Finances logical group of an invoice.
   *
   * Replaces the editable Finances slice of an invoice with the request
   * body and runs the recalculation pipeline. The body is a full
   * snapshot — all properties are required by the schema. Nullable
   * fields explicitly set to `null` are cleared (subject to per-state
   * constraints).
   *
   * The endpoint enforces a per-state locked-fields guard:
   *
   * - **Pre-financed states** (`Decision == DecisionPending && Status ==
   *   StatusWaiting`): no fields locked; any field may change.
   * - **`WaitingForInvoiceToEndCustomer`**: every field except
   *   `financed_date` and `interest_end_date_override` is locked.
   *   Additionally, `financed_date` may not be cleared (clearing in a
   *   state literally named "Financed" is rejected with
   *   `invoice_finances_invalid`).
   * - **`MonitoringEndCustomerPayments`, `WaitingFinalPayment`**: every
   *   field except `interest_end_date_override` is locked.
   * - **All other states** (`WaitingForReport`, `Completed`, all
   *   rejected/closed states): the endpoint rejects the request entirely
   *   with `invoice_state_locked`, `details.allowed = "none"`.
   *
   * A "locked" field is one whose to-be-persisted value (after
   * `service_fee` materialisation) must equal the persisted row value.
   * Decimal and Money fields are compared as decimals (so `"0.10"` and
   * `"0.1"` are equal). A request that would change a locked field is
   * rejected with `invoice_field_locked`.
   *
   * `service_fee` semantics: a body value of `null` materialises to the
   * `ServiceFee` system setting captured at write time (snapshot, not
   * reference). A non-null body value is persisted verbatim. The
   * persisted row never contains `NULL` for `service_fee` after a
   * successful PUT.
   *
   * After applying the body and the per-state field constraints, the
   * server validates that the invoice satisfies the "minimum financeable
   * shape" predicate (`amount`, `due_date`, `financing_method_id`,
   * `guarantee` non-null; the financing-method-specific interest input
   * non-null) before persisting and returns the refreshed `Invoice`.
   *
   * State changes and derived/read-only fields are rejected by the
   * request schema (`additionalProperties: false`). Workflow transitions
   * remain on `POST /invoices/{id}/workflow/event`. Single-field override
   * mutations may still use `PATCH /invoices/{id}/interest-end-date-override`;
   * that endpoint will be retired once the v1 invoice-financing widget
   * is removed.
   *
   * `If-Match` is required by this contract for forward-compat with
   * functional etag verification. Today the server does not enforce
   * the header value; a future change will activate verification
   * without further API changes.
   *
   * `error_code` values returned with `422`:
   *
   * - `invoice_state_locked` — the request is blocked because the
   *   current state allows no Finances edits. `details.state` is the
   *   current state name; `details.allowed` is `"none"`.
   * - `invoice_field_locked` — the request would change one or more
   *   fields that are locked in the current state. `errors[]` names
   *   each offending field.
   * - `invoice_finances_invalid` — the post-update state fails a
   *   per-state field constraint (e.g. `financed_date: null` in
   *   `WaitingForInvoiceToEndCustomer`) or the minimum-financeable-shape
   *   predicate. `errors[]` lists each offending field with `field`
   *   and a human-readable `message`.
   * - `interest_rate_out_of_range` — the active interest field for the
   *   selected financing method (`daily_interest` for `DI`,
   *   `fixed_interest` for `FI`) falls outside its policy band, and the
   *   interest decision changed versus the persisted invoice. Unlike the
   *   codes above this is **overridable**: resend the identical body with
   *   `allow_interest_rate_override: true` to bypass the check. `details`
   *   carries `financing_method_id`, `field` (`daily_interest` or
   *   `fixed_interest`), `value` (the rejected decimal as a string),
   *   `min` and `max` (the band bounds as strings), and `bound`
   *   (`"above"` when `value > max`, `"below"` when `value < min`).
   *
   * Requires the `invoice:edit-finances` permission (403 otherwise).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `replaceInvoiceFinances()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  replaceInvoiceFinances$Response(params: {

    /**
     * etag from the Invoice object, required for optimistic concurrency
     */
    'If-Match'?: string;
    id: number;
    context?: HttpContext
    body: ReplaceInvoiceFinancesRequest
  }
): Observable<StrictHttpResponse<Invoice>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.ReplaceInvoiceFinancesPath, 'put');
    if (params) {
      rb.header('If-Match', params['If-Match'], {});
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Invoice>;
      })
    );
  }

  /**
   * Replace the Finances logical group of an invoice.
   *
   * Replaces the editable Finances slice of an invoice with the request
   * body and runs the recalculation pipeline. The body is a full
   * snapshot — all properties are required by the schema. Nullable
   * fields explicitly set to `null` are cleared (subject to per-state
   * constraints).
   *
   * The endpoint enforces a per-state locked-fields guard:
   *
   * - **Pre-financed states** (`Decision == DecisionPending && Status ==
   *   StatusWaiting`): no fields locked; any field may change.
   * - **`WaitingForInvoiceToEndCustomer`**: every field except
   *   `financed_date` and `interest_end_date_override` is locked.
   *   Additionally, `financed_date` may not be cleared (clearing in a
   *   state literally named "Financed" is rejected with
   *   `invoice_finances_invalid`).
   * - **`MonitoringEndCustomerPayments`, `WaitingFinalPayment`**: every
   *   field except `interest_end_date_override` is locked.
   * - **All other states** (`WaitingForReport`, `Completed`, all
   *   rejected/closed states): the endpoint rejects the request entirely
   *   with `invoice_state_locked`, `details.allowed = "none"`.
   *
   * A "locked" field is one whose to-be-persisted value (after
   * `service_fee` materialisation) must equal the persisted row value.
   * Decimal and Money fields are compared as decimals (so `"0.10"` and
   * `"0.1"` are equal). A request that would change a locked field is
   * rejected with `invoice_field_locked`.
   *
   * `service_fee` semantics: a body value of `null` materialises to the
   * `ServiceFee` system setting captured at write time (snapshot, not
   * reference). A non-null body value is persisted verbatim. The
   * persisted row never contains `NULL` for `service_fee` after a
   * successful PUT.
   *
   * After applying the body and the per-state field constraints, the
   * server validates that the invoice satisfies the "minimum financeable
   * shape" predicate (`amount`, `due_date`, `financing_method_id`,
   * `guarantee` non-null; the financing-method-specific interest input
   * non-null) before persisting and returns the refreshed `Invoice`.
   *
   * State changes and derived/read-only fields are rejected by the
   * request schema (`additionalProperties: false`). Workflow transitions
   * remain on `POST /invoices/{id}/workflow/event`. Single-field override
   * mutations may still use `PATCH /invoices/{id}/interest-end-date-override`;
   * that endpoint will be retired once the v1 invoice-financing widget
   * is removed.
   *
   * `If-Match` is required by this contract for forward-compat with
   * functional etag verification. Today the server does not enforce
   * the header value; a future change will activate verification
   * without further API changes.
   *
   * `error_code` values returned with `422`:
   *
   * - `invoice_state_locked` — the request is blocked because the
   *   current state allows no Finances edits. `details.state` is the
   *   current state name; `details.allowed` is `"none"`.
   * - `invoice_field_locked` — the request would change one or more
   *   fields that are locked in the current state. `errors[]` names
   *   each offending field.
   * - `invoice_finances_invalid` — the post-update state fails a
   *   per-state field constraint (e.g. `financed_date: null` in
   *   `WaitingForInvoiceToEndCustomer`) or the minimum-financeable-shape
   *   predicate. `errors[]` lists each offending field with `field`
   *   and a human-readable `message`.
   * - `interest_rate_out_of_range` — the active interest field for the
   *   selected financing method (`daily_interest` for `DI`,
   *   `fixed_interest` for `FI`) falls outside its policy band, and the
   *   interest decision changed versus the persisted invoice. Unlike the
   *   codes above this is **overridable**: resend the identical body with
   *   `allow_interest_rate_override: true` to bypass the check. `details`
   *   carries `financing_method_id`, `field` (`daily_interest` or
   *   `fixed_interest`), `value` (the rejected decimal as a string),
   *   `min` and `max` (the band bounds as strings), and `bound`
   *   (`"above"` when `value > max`, `"below"` when `value < min`).
   *
   * Requires the `invoice:edit-finances` permission (403 otherwise).
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `replaceInvoiceFinances$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  replaceInvoiceFinances(params: {

    /**
     * etag from the Invoice object, required for optimistic concurrency
     */
    'If-Match'?: string;
    id: number;
    context?: HttpContext
    body: ReplaceInvoiceFinancesRequest
  }
): Observable<Invoice> {

    return this.replaceInvoiceFinances$Response(params).pipe(
      map((r: StrictHttpResponse<Invoice>) => r.body as Invoice)
    );
  }

  /**
   * Path part for operation replaceInvoiceInformation
   */
  static readonly ReplaceInvoiceInformationPath = '/invoices/{id}/information';

  /**
   * Replace the Information logical group of an invoice.
   *
   * Replaces the editable Information slice of an invoice with the
   * request body and runs the same recalculation pipeline as
   * `PUT /invoices/{id}/finances`.
   *
   * The invoice's `date`, `due_date`, `number` and `amount` can be
   * unknown early on, and once known they are corrected, never cleared.
   * So these four properties are optional and non-nullable: an absent
   * one keeps the stored value, whether it is set or empty, and a value
   * replaces it. `null` for any of them is rejected with `400`. A client
   * therefore leaves out a detail it does not know, and a change to one
   * detail, such as the IBAN, never depends on the others. Every other
   * property is required; nullable properties explicitly set to `null`
   * are cleared (subject to per-state constraints).
   *
   * The endpoint enforces a per-state locked-fields guard. A property
   * the body leaves out keeps its stored value, so it never counts as
   * a change to a locked field:
   *
   * - **Pre-financed states** (`Decision == DecisionPending && Status ==
   *   StatusWaiting`): no fields locked; any field may change.
   * - **`WaitingForInvoiceToEndCustomer`**: every field except `iban`,
   *   `lead_source_id`, `responsible_seller_id`, and `date` is locked.
   * - **`MonitoringEndCustomerPayments`, `WaitingFinalPayment`**: every
   *   field except `iban`, `lead_source_id`, and
   *   `responsible_seller_id` is locked.
   * - **`WaitingForReport`, `Completed`**: every field except
   *   `lead_source_id` and `responsible_seller_id` is locked.
   * - **All other states** (rejected/closed): the endpoint rejects the
   *   request entirely with `invoice_state_locked`,
   *   `details.allowed = "none"`.
   *
   * So `express_payment` locks once the invoice is financed, from
   * `WaitingForInvoiceToEndCustomer` on: the invoice keeps recording how
   * its advance was paid. Before financing it can change, which re-prices
   * the invoice.
   *
   * After the guard, a request that changes `date` or `due_date` (by
   * calendar day) is checked: `date` must not be after `due_date` (the
   * same day is allowed), and a changed `date` must not be after today
   * in the `Europe/Helsinki` business calendar. A request that changes
   * neither is not checked, so a stored pair that already breaks a rule
   * does not block an unrelated edit.
   *
   * After applying the body the server runs
   * `materializeExpressPaymentFee` followed by
   * `updateCalculatedFields(updateLastPaymentDate=false)` regardless of
   * which Information field actually changed, so derived figures
   * (`amount_financed`, `financing_fee`, `financed_days`,
   * `final_payment_amount`, `total_profit`, `penalty_interest_fee`)
   * always reflect the calculator's output for the post-update state.
   * `last_payment_date` and `final_payment_date` are owned by other
   * flows and are not touched here.
   *
   * `express_payment` is a `boolean` on the wire (the legacy
   * `1`/`2` integer encoding is mapped at the handler boundary).
   *
   * State changes and derived/read-only fields are rejected by the
   * request schema (`additionalProperties: false`). Workflow transitions
   * remain on `POST /invoices/{id}/workflow/event`.
   *
   * `If-Match` is required by this contract for forward-compat with
   * functional etag verification. Today the server does not enforce
   * the header value; a future change will activate verification
   * without further API changes.
   *
   * `error_code` values returned with `422`:
   *
   * - `invoice_state_locked` — the request is blocked because the
   *   current state allows no Information edits. `details.state` is the
   *   current state name; `details.allowed` is `"none"`.
   * - `invoice_field_locked` — the request would change one or more
   *   fields that are locked in the current state. `errors[]` names
   *   each offending field in OpenAPI declaration order.
   * - `invoice_information_invalid` — a value the user can fix is
   *   refused. `errors[]` lists each problem with its `field` and a
   *   human-readable `message`:
   *   - `iban`, message `Not a valid IBAN`: a non-null `iban`, the
   *     empty string included, is not a valid IBAN once whitespace is
   *     removed and letters are upper-cased. It is checked before the
   *     state guard, the locked-fields guard and the date checks, and
   *     is then the only error, beside an `original_reference_number`
   *     error. An `iban` that is not a string is a malformed body,
   *     `400`.
   *   - `original_reference_number`, message
   *     `Can be corrected but not cleared`: the body carries
   *     `original_reference_number` as `null`, as the empty string, or
   *     as only whitespace.
   *   - `original_reference_number`, message
   *     `Not a valid Finnish reference number or RF creditor reference`:
   *     the body carries `original_reference_number` as a value that,
   *     once whitespace is removed and a leading `rf` upper-cased, is
   *     neither a valid Finnish reference number nor an RF creditor
   *     reference. Both `original_reference_number` errors are checked
   *     with `iban`, before the other checks. A value that is not a
   *     string is a malformed body, `400`.
   *   - `date` or `due_date`: the request changes `date` or `due_date`
   *     and the result breaks a date check above. `field` is the field
   *     the request changed: `date`, or `due_date` when only it changed.
   * - `invoice_persisted_iban_invalid` — the invoice's persisted
   *   `BankAccount` value is not a valid IBAN, so the locked-field
   *   comparator cannot determine whether the body would change it.
   *   `details.invoice_id` and `details.persisted_iban` identify the
   *   offending row. Operators must repair the data (e.g. via
   *   `cctool-cli iban normalize update --table Invoices`) before
   *   edits to that invoice will succeed.
   *
   * Requires the `invoice:edit-information` permission (403 otherwise).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `replaceInvoiceInformation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  replaceInvoiceInformation$Response(params: {

    /**
     * etag from the Invoice object, required for optimistic concurrency
     */
    'If-Match'?: string;
    id: number;
    context?: HttpContext
    body: ReplaceInvoiceInformationRequest
  }
): Observable<StrictHttpResponse<Invoice>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.ReplaceInvoiceInformationPath, 'put');
    if (params) {
      rb.header('If-Match', params['If-Match'], {});
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Invoice>;
      })
    );
  }

  /**
   * Replace the Information logical group of an invoice.
   *
   * Replaces the editable Information slice of an invoice with the
   * request body and runs the same recalculation pipeline as
   * `PUT /invoices/{id}/finances`.
   *
   * The invoice's `date`, `due_date`, `number` and `amount` can be
   * unknown early on, and once known they are corrected, never cleared.
   * So these four properties are optional and non-nullable: an absent
   * one keeps the stored value, whether it is set or empty, and a value
   * replaces it. `null` for any of them is rejected with `400`. A client
   * therefore leaves out a detail it does not know, and a change to one
   * detail, such as the IBAN, never depends on the others. Every other
   * property is required; nullable properties explicitly set to `null`
   * are cleared (subject to per-state constraints).
   *
   * The endpoint enforces a per-state locked-fields guard. A property
   * the body leaves out keeps its stored value, so it never counts as
   * a change to a locked field:
   *
   * - **Pre-financed states** (`Decision == DecisionPending && Status ==
   *   StatusWaiting`): no fields locked; any field may change.
   * - **`WaitingForInvoiceToEndCustomer`**: every field except `iban`,
   *   `lead_source_id`, `responsible_seller_id`, and `date` is locked.
   * - **`MonitoringEndCustomerPayments`, `WaitingFinalPayment`**: every
   *   field except `iban`, `lead_source_id`, and
   *   `responsible_seller_id` is locked.
   * - **`WaitingForReport`, `Completed`**: every field except
   *   `lead_source_id` and `responsible_seller_id` is locked.
   * - **All other states** (rejected/closed): the endpoint rejects the
   *   request entirely with `invoice_state_locked`,
   *   `details.allowed = "none"`.
   *
   * So `express_payment` locks once the invoice is financed, from
   * `WaitingForInvoiceToEndCustomer` on: the invoice keeps recording how
   * its advance was paid. Before financing it can change, which re-prices
   * the invoice.
   *
   * After the guard, a request that changes `date` or `due_date` (by
   * calendar day) is checked: `date` must not be after `due_date` (the
   * same day is allowed), and a changed `date` must not be after today
   * in the `Europe/Helsinki` business calendar. A request that changes
   * neither is not checked, so a stored pair that already breaks a rule
   * does not block an unrelated edit.
   *
   * After applying the body the server runs
   * `materializeExpressPaymentFee` followed by
   * `updateCalculatedFields(updateLastPaymentDate=false)` regardless of
   * which Information field actually changed, so derived figures
   * (`amount_financed`, `financing_fee`, `financed_days`,
   * `final_payment_amount`, `total_profit`, `penalty_interest_fee`)
   * always reflect the calculator's output for the post-update state.
   * `last_payment_date` and `final_payment_date` are owned by other
   * flows and are not touched here.
   *
   * `express_payment` is a `boolean` on the wire (the legacy
   * `1`/`2` integer encoding is mapped at the handler boundary).
   *
   * State changes and derived/read-only fields are rejected by the
   * request schema (`additionalProperties: false`). Workflow transitions
   * remain on `POST /invoices/{id}/workflow/event`.
   *
   * `If-Match` is required by this contract for forward-compat with
   * functional etag verification. Today the server does not enforce
   * the header value; a future change will activate verification
   * without further API changes.
   *
   * `error_code` values returned with `422`:
   *
   * - `invoice_state_locked` — the request is blocked because the
   *   current state allows no Information edits. `details.state` is the
   *   current state name; `details.allowed` is `"none"`.
   * - `invoice_field_locked` — the request would change one or more
   *   fields that are locked in the current state. `errors[]` names
   *   each offending field in OpenAPI declaration order.
   * - `invoice_information_invalid` — a value the user can fix is
   *   refused. `errors[]` lists each problem with its `field` and a
   *   human-readable `message`:
   *   - `iban`, message `Not a valid IBAN`: a non-null `iban`, the
   *     empty string included, is not a valid IBAN once whitespace is
   *     removed and letters are upper-cased. It is checked before the
   *     state guard, the locked-fields guard and the date checks, and
   *     is then the only error, beside an `original_reference_number`
   *     error. An `iban` that is not a string is a malformed body,
   *     `400`.
   *   - `original_reference_number`, message
   *     `Can be corrected but not cleared`: the body carries
   *     `original_reference_number` as `null`, as the empty string, or
   *     as only whitespace.
   *   - `original_reference_number`, message
   *     `Not a valid Finnish reference number or RF creditor reference`:
   *     the body carries `original_reference_number` as a value that,
   *     once whitespace is removed and a leading `rf` upper-cased, is
   *     neither a valid Finnish reference number nor an RF creditor
   *     reference. Both `original_reference_number` errors are checked
   *     with `iban`, before the other checks. A value that is not a
   *     string is a malformed body, `400`.
   *   - `date` or `due_date`: the request changes `date` or `due_date`
   *     and the result breaks a date check above. `field` is the field
   *     the request changed: `date`, or `due_date` when only it changed.
   * - `invoice_persisted_iban_invalid` — the invoice's persisted
   *   `BankAccount` value is not a valid IBAN, so the locked-field
   *   comparator cannot determine whether the body would change it.
   *   `details.invoice_id` and `details.persisted_iban` identify the
   *   offending row. Operators must repair the data (e.g. via
   *   `cctool-cli iban normalize update --table Invoices`) before
   *   edits to that invoice will succeed.
   *
   * Requires the `invoice:edit-information` permission (403 otherwise).
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `replaceInvoiceInformation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  replaceInvoiceInformation(params: {

    /**
     * etag from the Invoice object, required for optimistic concurrency
     */
    'If-Match'?: string;
    id: number;
    context?: HttpContext
    body: ReplaceInvoiceInformationRequest
  }
): Observable<Invoice> {

    return this.replaceInvoiceInformation$Response(params).pipe(
      map((r: StrictHttpResponse<Invoice>) => r.body as Invoice)
    );
  }

  /**
   * Path part for operation setInvoiceInterestEndDateOverride
   */
  static readonly SetInvoiceInterestEndDateOverridePath = '/invoices/{id}/interest-end-date-override';

  /**
   * Set or clear the interest end date override.
   *
   * Sets or clears `interest_end_date_override` for the invoice. When set,
   * the calculator uses the override as the period-end date for day-counting
   * (FinancedDays, PenaltyInterestFee) instead of the default
   * `max(last_payment_date, due_date)`. Pass `null` in the body to clear
   * an existing override.
   *
   * After persisting the new value, the server runs the same recalculation
   * that `POST /invoices/{id}/recalculate` performs, so all derived money
   * fields reflect the updated window in the response.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setInvoiceInterestEndDateOverride()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  setInvoiceInterestEndDateOverride$Response(params: {
    id: number;
    context?: HttpContext
    body: SetInterestEndDateOverrideRequest
  }
): Observable<StrictHttpResponse<Invoice>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.SetInvoiceInterestEndDateOverridePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Invoice>;
      })
    );
  }

  /**
   * Set or clear the interest end date override.
   *
   * Sets or clears `interest_end_date_override` for the invoice. When set,
   * the calculator uses the override as the period-end date for day-counting
   * (FinancedDays, PenaltyInterestFee) instead of the default
   * `max(last_payment_date, due_date)`. Pass `null` in the body to clear
   * an existing override.
   *
   * After persisting the new value, the server runs the same recalculation
   * that `POST /invoices/{id}/recalculate` performs, so all derived money
   * fields reflect the updated window in the response.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `setInvoiceInterestEndDateOverride$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  setInvoiceInterestEndDateOverride(params: {
    id: number;
    context?: HttpContext
    body: SetInterestEndDateOverrideRequest
  }
): Observable<Invoice> {

    return this.setInvoiceInterestEndDateOverride$Response(params).pipe(
      map((r: StrictHttpResponse<Invoice>) => r.body as Invoice)
    );
  }

  /**
   * Path part for operation previewInvoicePdf
   */
  static readonly PreviewInvoicePdfPath = '/admin/invoices/{id}/preview-pdf';

  /**
   * Preview an invoice document as a PDF.
   *
   * Renders the requested document through the same pipeline as the
   * matching generate workflow (GenerateOfferWorkflow for `offer`,
   * GenerateInvoiceDocumentsWorkflow's build → parse → render path
   * for `invoice` / `subfinancing_invoice`, and the transfer invoice
   * builder for `transfer_invoice`) but streams the resulting
   * PDF bytes directly in the response — no attachments are written,
   * no blobs are uploaded, no invoice or reference number is
   * persisted, and no domain events are emitted. A rendered preview is
   * audit-logged with its partner variant; a `transfer_invoice`
   * preview, including one that ends in a build error, is logged with
   * the invoice's configuration name.
   *
   * Requires the `invoice-docs:preview` permission (403 otherwise).
   *
   * `422` answers a document that cannot be built:
   *
   * - for `kind=transfer_invoice`, a transfer invoice build error;
   *   `error_code` is one of the `TransferInvoiceBuildErrorCode`
   *   values, the same codes
   *   `POST /admin/invoices/{id}/preview-transfer-invoice` returns;
   * - an InvoiceConfiguration whose view name cannot render the
   *   requested kind (for `invoice` and `transfer_invoice`, its invoice
   *   view name), or an `invoice` preview of an invoice without a
   *   finance date. These carry no `error_code`.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `previewInvoicePdf()` instead.
   *
   * This method doesn't expect any request body.
   */
  previewInvoicePdf$Response(params: {
    id: number;

    /**
     * Document kind to preview. &#x60;offer&#x60; renders the offer PDF;
     * &#x60;invoice&#x60; and &#x60;subfinancing_invoice&#x60; build the Finvoice in
     * memory and render the invoice PDF from the parsed Finvoice
     * (the subfinancing variant substitutes today&#x27;s date when the
     * finance date is missing). &#x60;transfer_invoice&#x60; builds the
     * transfer invoice (the same document
     * &#x60;POST /admin/invoices/{id}/preview-transfer-invoice&#x60; returns
     * as XML) and renders its PDF from the parsed Finvoice. All paths
     * write nothing. Additional kinds (general_terms, final_report)
     * will be added later.
     */
    kind: 'offer' | 'invoice' | 'subfinancing_invoice' | 'transfer_invoice';

    /**
     * Overrides the partner variant. When omitted, the variant is
     * taken from the invoice&#x27;s InvoiceConfiguration. For an invoice
     * without a configuration, &#x60;offer&#x60; needs a variant (400 without
     * one), and &#x60;invoice&#x60; and &#x60;subfinancing_invoice&#x60; answer 400
     * (&quot;invoice has no configuration; cannot build the Finvoice&quot;)
     * whatever the variant, because they build the Finvoice from the
     * configuration. Not accepted with &#x60;kind&#x3D;transfer_invoice&#x60; (400):
     * the transfer invoice is always built with the invoice&#x27;s own
     * configuration.
     */
    variant?: 'corona' | 'arex' | 'front' | 'lumi' | 'svea';
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.PreviewInvoicePdfPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('kind', params.kind, {});
      rb.query('variant', params.variant, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/pdf',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Preview an invoice document as a PDF.
   *
   * Renders the requested document through the same pipeline as the
   * matching generate workflow (GenerateOfferWorkflow for `offer`,
   * GenerateInvoiceDocumentsWorkflow's build → parse → render path
   * for `invoice` / `subfinancing_invoice`, and the transfer invoice
   * builder for `transfer_invoice`) but streams the resulting
   * PDF bytes directly in the response — no attachments are written,
   * no blobs are uploaded, no invoice or reference number is
   * persisted, and no domain events are emitted. A rendered preview is
   * audit-logged with its partner variant; a `transfer_invoice`
   * preview, including one that ends in a build error, is logged with
   * the invoice's configuration name.
   *
   * Requires the `invoice-docs:preview` permission (403 otherwise).
   *
   * `422` answers a document that cannot be built:
   *
   * - for `kind=transfer_invoice`, a transfer invoice build error;
   *   `error_code` is one of the `TransferInvoiceBuildErrorCode`
   *   values, the same codes
   *   `POST /admin/invoices/{id}/preview-transfer-invoice` returns;
   * - an InvoiceConfiguration whose view name cannot render the
   *   requested kind (for `invoice` and `transfer_invoice`, its invoice
   *   view name), or an `invoice` preview of an invoice without a
   *   finance date. These carry no `error_code`.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `previewInvoicePdf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  previewInvoicePdf(params: {
    id: number;

    /**
     * Document kind to preview. &#x60;offer&#x60; renders the offer PDF;
     * &#x60;invoice&#x60; and &#x60;subfinancing_invoice&#x60; build the Finvoice in
     * memory and render the invoice PDF from the parsed Finvoice
     * (the subfinancing variant substitutes today&#x27;s date when the
     * finance date is missing). &#x60;transfer_invoice&#x60; builds the
     * transfer invoice (the same document
     * &#x60;POST /admin/invoices/{id}/preview-transfer-invoice&#x60; returns
     * as XML) and renders its PDF from the parsed Finvoice. All paths
     * write nothing. Additional kinds (general_terms, final_report)
     * will be added later.
     */
    kind: 'offer' | 'invoice' | 'subfinancing_invoice' | 'transfer_invoice';

    /**
     * Overrides the partner variant. When omitted, the variant is
     * taken from the invoice&#x27;s InvoiceConfiguration. For an invoice
     * without a configuration, &#x60;offer&#x60; needs a variant (400 without
     * one), and &#x60;invoice&#x60; and &#x60;subfinancing_invoice&#x60; answer 400
     * (&quot;invoice has no configuration; cannot build the Finvoice&quot;)
     * whatever the variant, because they build the Finvoice from the
     * configuration. Not accepted with &#x60;kind&#x3D;transfer_invoice&#x60; (400):
     * the transfer invoice is always built with the invoice&#x27;s own
     * configuration.
     */
    variant?: 'corona' | 'arex' | 'front' | 'lumi' | 'svea';
    context?: HttpContext
  }
): Observable<Blob> {

    return this.previewInvoicePdf$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation previewTransferInvoice
   */
  static readonly PreviewTransferInvoicePath = '/admin/invoices/{id}/preview-transfer-invoice';

  /**
   * Preview the transfer invoice built for an invoice.
   *
   * Builds the transfer invoice for the invoice exactly as it would be
   * built for sending: the seller's own invoice, with the invoice's
   * InvoiceConfiguration as the payee, Corona Capital as the sender,
   * Corona's `new_number` and `new_reference_number` as the invoice
   * number and payment reference, and the configuration's transfer
   * statement added. The source track is chosen by data (see
   * `TransferInvoiceTrack`).
   *
   * The response carries the track, the source Finvoice (on the
   * `original` track), the transfer invoice Finvoice, the schema
   * validation of both, and the findings: disagreements between the
   * original and the invoice record, and schema defects. A finding
   * does not stop the document from being built. The rendered PDF of
   * the same document is
   * `POST /admin/invoices/{id}/preview-pdf?kind=transfer_invoice`.
   *
   * Previewing writes nothing: no attachment row, no blob, no invoice
   * or reference number (an invoice without them gets the values
   * generation would mint, which are not persisted), no state change
   * and no domain event. Every preview, including one that ends in a
   * build error, is audit-logged with the invoice's configuration.
   *
   * `error_code` values returned with `422`: the
   * `TransferInvoiceBuildErrorCode` values. A build error means no
   * document can be produced; `message` says which value is missing
   * or wrong.
   *
   * Requires the `invoice-docs:preview` permission (403 otherwise).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `previewTransferInvoice()` instead.
   *
   * This method doesn't expect any request body.
   */
  previewTransferInvoice$Response(params: {
    id: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<TransferInvoicePreview>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.PreviewTransferInvoicePath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TransferInvoicePreview>;
      })
    );
  }

  /**
   * Preview the transfer invoice built for an invoice.
   *
   * Builds the transfer invoice for the invoice exactly as it would be
   * built for sending: the seller's own invoice, with the invoice's
   * InvoiceConfiguration as the payee, Corona Capital as the sender,
   * Corona's `new_number` and `new_reference_number` as the invoice
   * number and payment reference, and the configuration's transfer
   * statement added. The source track is chosen by data (see
   * `TransferInvoiceTrack`).
   *
   * The response carries the track, the source Finvoice (on the
   * `original` track), the transfer invoice Finvoice, the schema
   * validation of both, and the findings: disagreements between the
   * original and the invoice record, and schema defects. A finding
   * does not stop the document from being built. The rendered PDF of
   * the same document is
   * `POST /admin/invoices/{id}/preview-pdf?kind=transfer_invoice`.
   *
   * Previewing writes nothing: no attachment row, no blob, no invoice
   * or reference number (an invoice without them gets the values
   * generation would mint, which are not persisted), no state change
   * and no domain event. Every preview, including one that ends in a
   * build error, is audit-logged with the invoice's configuration.
   *
   * `error_code` values returned with `422`: the
   * `TransferInvoiceBuildErrorCode` values. A build error means no
   * document can be produced; `message` says which value is missing
   * or wrong.
   *
   * Requires the `invoice-docs:preview` permission (403 otherwise).
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `previewTransferInvoice$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  previewTransferInvoice(params: {
    id: number;
    context?: HttpContext
  }
): Observable<TransferInvoicePreview> {

    return this.previewTransferInvoice$Response(params).pipe(
      map((r: StrictHttpResponse<TransferInvoicePreview>) => r.body as TransferInvoicePreview)
    );
  }

  /**
   * Path part for operation generateOffer
   */
  static readonly GenerateOfferPath = '/invoices/{id}/generate-offer';

  /**
   * Generate an offer PDF bundle for an invoice.
   *
   * Starts the GenerateOfferWorkflow Temporal workflow for the
   * invoice. Renders the Offer and General Terms PDFs, merges them
   * with the non-watermarked Original Invoice (and its attachments)
   * into a single OfferBundle PDF, and — when `recipients` is
   * non-empty and the email is successfully sent — advances the
   * invoice state from `WaitingForOfferToBeSent` to
   * `WaitingForOfferApproval`.
   *
   * Returns immediately (202) with the workflow ID; callers can
   * poll the invoice's attachments list for completion.
   *
   * ## Idempotency
   *
   * The workflow ID is stable on the tuple
   * `(invoice_id, sorted-canonicalised-recipients)`. A double-click
   * (or any other re-fire that arrives while the previous workflow
   * is still running) reuses the in-flight workflow and the handler
   * returns 202 with the existing workflow ID — no second workflow
   * is started, no second email is sent. Once the previous run
   * reaches a terminal state (Completed, Failed, Cancelled), a new
   * request with the same recipients starts a fresh workflow under
   * the same ID (Temporal's default AllowDuplicate policy). This is
   * the desired shape for "send the same offer again later" flows,
   * such as a renegotiated offer to the same customer — see the
   * `allow_in_unexpected_state` flag.
   *
   * Recipient canonicalisation lower-cases each address, trims
   * whitespace, drops empty entries, and sorts the resulting list,
   * so requests that differ only in order or casing reuse the same
   * workflow.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `generateOffer()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  generateOffer$Response(params: {
    id: number;
    context?: HttpContext
    body?: GenerateOfferRequestBody
  }
): Observable<StrictHttpResponse<GenerateOfferAcceptedResult>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.GenerateOfferPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GenerateOfferAcceptedResult>;
      })
    );
  }

  /**
   * Generate an offer PDF bundle for an invoice.
   *
   * Starts the GenerateOfferWorkflow Temporal workflow for the
   * invoice. Renders the Offer and General Terms PDFs, merges them
   * with the non-watermarked Original Invoice (and its attachments)
   * into a single OfferBundle PDF, and — when `recipients` is
   * non-empty and the email is successfully sent — advances the
   * invoice state from `WaitingForOfferToBeSent` to
   * `WaitingForOfferApproval`.
   *
   * Returns immediately (202) with the workflow ID; callers can
   * poll the invoice's attachments list for completion.
   *
   * ## Idempotency
   *
   * The workflow ID is stable on the tuple
   * `(invoice_id, sorted-canonicalised-recipients)`. A double-click
   * (or any other re-fire that arrives while the previous workflow
   * is still running) reuses the in-flight workflow and the handler
   * returns 202 with the existing workflow ID — no second workflow
   * is started, no second email is sent. Once the previous run
   * reaches a terminal state (Completed, Failed, Cancelled), a new
   * request with the same recipients starts a fresh workflow under
   * the same ID (Temporal's default AllowDuplicate policy). This is
   * the desired shape for "send the same offer again later" flows,
   * such as a renegotiated offer to the same customer — see the
   * `allow_in_unexpected_state` flag.
   *
   * Recipient canonicalisation lower-cases each address, trims
   * whitespace, drops empty entries, and sorts the resulting list,
   * so requests that differ only in order or casing reuse the same
   * workflow.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `generateOffer$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  generateOffer(params: {
    id: number;
    context?: HttpContext
    body?: GenerateOfferRequestBody
  }
): Observable<GenerateOfferAcceptedResult> {

    return this.generateOffer$Response(params).pipe(
      map((r: StrictHttpResponse<GenerateOfferAcceptedResult>) => r.body as GenerateOfferAcceptedResult)
    );
  }

  /**
   * Path part for operation generateInvoice
   */
  static readonly GenerateInvoicePath = '/invoices/{id}/generate-invoice';

  /**
   * Generate the invoice Finvoice + PDF for an invoice.
   *
   * Starts GenerateInvoiceDocumentsWorkflow in `Real` mode: builds the
   * Finvoice 3.0 XML, renders the invoice PDF from the parsed Finvoice,
   * and stores both as `Invoice Finvoice` / `Invoice` attachments.
   * Sends nothing. Returns 202 with the workflow id; poll the
   * attachments list for completion.
   *
   * Before starting, the handler validates readiness and returns 422
   * with every violation when the invoice is not ready (missing
   * configuration, unresolvable invoice view, missing due date,
   * incomplete end-customer invoicing fields, or — in `Real` mode —
   * a missing finance date).
   *
   * Requires the `invoice-docs:generate` permission (403 otherwise).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `generateInvoice()` instead.
   *
   * This method doesn't expect any request body.
   */
  generateInvoice$Response(params: {
    id: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<GenerateInvoiceAcceptedResult>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.GenerateInvoicePath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GenerateInvoiceAcceptedResult>;
      })
    );
  }

  /**
   * Generate the invoice Finvoice + PDF for an invoice.
   *
   * Starts GenerateInvoiceDocumentsWorkflow in `Real` mode: builds the
   * Finvoice 3.0 XML, renders the invoice PDF from the parsed Finvoice,
   * and stores both as `Invoice Finvoice` / `Invoice` attachments.
   * Sends nothing. Returns 202 with the workflow id; poll the
   * attachments list for completion.
   *
   * Before starting, the handler validates readiness and returns 422
   * with every violation when the invoice is not ready (missing
   * configuration, unresolvable invoice view, missing due date,
   * incomplete end-customer invoicing fields, or — in `Real` mode —
   * a missing finance date).
   *
   * Requires the `invoice-docs:generate` permission (403 otherwise).
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `generateInvoice$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  generateInvoice(params: {
    id: number;
    context?: HttpContext
  }
): Observable<GenerateInvoiceAcceptedResult> {

    return this.generateInvoice$Response(params).pipe(
      map((r: StrictHttpResponse<GenerateInvoiceAcceptedResult>) => r.body as GenerateInvoiceAcceptedResult)
    );
  }

  /**
   * Path part for operation generateSubfinancingInvoice
   */
  static readonly GenerateSubfinancingInvoicePath = '/invoices/{id}/generate-subfinancing-invoice';

  /**
   * Generate the subfinancing invoice Finvoice + PDF for an invoice.
   *
   * Starts GenerateInvoiceDocumentsWorkflow in `Subfinancing` mode:
   * content-identical to the real invoice but stored under the distinct
   * `Subfinancing Invoice Finvoice` / `Subfinancing Invoice` attachment
   * types, and — when the finance date is missing — dated today. Sends
   * nothing; the factoring handler downloads the PDF for the manual Lumi
   * flow. Returns 202 with the workflow id.
   *
   * Readiness is validated identically to generate-invoice **except**
   * that a missing finance date is not a violation (it is substituted
   * with the current date), and that the subfinancing invoice-number
   * suffix precondition is checked:
   * `missing_subfinancing_invoice_number_suffix` (the configuration has
   * no `PaymentTransferCode`). It is also reported by
   * `/invoices/{id}/send-subfinancing`, which validates through this
   * same check; it is not overridable.
   *
   * The generated documents carry the subfinancing invoice number: the
   * invoice's `NewInvoiceNumber` suffixed with the configuration's
   * `PaymentTransferCode` (Lumi's is `L`, giving `101139250L`), which
   * keeps them distinct from the end-customer documents under Apix's
   * receiver-independent duplicate detection.
   *
   * Requires the `invoice-docs:generate` permission (403 otherwise).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `generateSubfinancingInvoice()` instead.
   *
   * This method doesn't expect any request body.
   */
  generateSubfinancingInvoice$Response(params: {
    id: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<GenerateInvoiceAcceptedResult>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.GenerateSubfinancingInvoicePath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GenerateInvoiceAcceptedResult>;
      })
    );
  }

  /**
   * Generate the subfinancing invoice Finvoice + PDF for an invoice.
   *
   * Starts GenerateInvoiceDocumentsWorkflow in `Subfinancing` mode:
   * content-identical to the real invoice but stored under the distinct
   * `Subfinancing Invoice Finvoice` / `Subfinancing Invoice` attachment
   * types, and — when the finance date is missing — dated today. Sends
   * nothing; the factoring handler downloads the PDF for the manual Lumi
   * flow. Returns 202 with the workflow id.
   *
   * Readiness is validated identically to generate-invoice **except**
   * that a missing finance date is not a violation (it is substituted
   * with the current date), and that the subfinancing invoice-number
   * suffix precondition is checked:
   * `missing_subfinancing_invoice_number_suffix` (the configuration has
   * no `PaymentTransferCode`). It is also reported by
   * `/invoices/{id}/send-subfinancing`, which validates through this
   * same check; it is not overridable.
   *
   * The generated documents carry the subfinancing invoice number: the
   * invoice's `NewInvoiceNumber` suffixed with the configuration's
   * `PaymentTransferCode` (Lumi's is `L`, giving `101139250L`), which
   * keeps them distinct from the end-customer documents under Apix's
   * receiver-independent duplicate detection.
   *
   * Requires the `invoice-docs:generate` permission (403 otherwise).
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `generateSubfinancingInvoice$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  generateSubfinancingInvoice(params: {
    id: number;
    context?: HttpContext
  }
): Observable<GenerateInvoiceAcceptedResult> {

    return this.generateSubfinancingInvoice$Response(params).pipe(
      map((r: StrictHttpResponse<GenerateInvoiceAcceptedResult>) => r.body as GenerateInvoiceAcceptedResult)
    );
  }

  /**
   * Path part for operation generateInvoiceNumber
   */
  static readonly GenerateInvoiceNumberPath = '/invoices/{id}/generate-invoice-number';

  /**
   * Generate the Corona invoice number and payment reference.
   *
   * Mints the invoice's `new_number` — the deterministic
   * prefix·invoice-id·ordinal-`0` number document generation would mint
   * — together with the matching `new_reference_number`, built from the
   * invoice configuration's reference-number prefix and the Finnish
   * 7-3-1 check digit, and persists both. The write is conditional on
   * the number being absent, so concurrent calls mint at most once.
   *
   * The status code says what happened:
   *
   * - `201 Created` — this call minted the number; the body is the
   *   updated invoice.
   * - `200 OK` — the invoice already carried a `new_number` that
   *   decodes to its own id; nothing was written and the body is the
   *   unchanged invoice.
   *
   * Repeating the call therefore never renumbers the invoice, unlike
   * the legacy `PATCH /apiv2/invoices/{id}/generateInvoiceNumber`
   * action this replaces. To bump the ordinal on purpose, use
   * `POST /invoices/{id}/advance-invoice-number`.
   *
   * `error_code` values returned with `422`:
   *
   * - `missing_configuration` — the invoice has no `new_number` to
   *   return and no invoice configuration, so the reference-number
   *   prefix a mint would need is unknown. `message` tells the handler
   *   to assign a configuration first; this is the case the legacy
   *   action failed with a `500`. A configuration is only needed to
   *   mint: an invoice that already carries a `new_number` decoding to
   *   its own id answers `200 OK` whether or not it has one.
   * - `invoice_number_not_derivable` — the stored `new_number` does not
   *   decode to this invoice's id, i.e. it was hand-edited or
   *   imported. It is refused rather than silently overwritten; if that
   *   is really intended, change both `new_invoice_number` and
   *   `new_reference_number` through
   *   `PUT /invoices/{id}/information` — they are independent fields
   *   and neither is recomputed from the other.
   *
   * Requires the `invoice-docs:generate` permission (403 otherwise).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `generateInvoiceNumber()` instead.
   *
   * This method doesn't expect any request body.
   */
  generateInvoiceNumber$Response(params: {
    id: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Invoice>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.GenerateInvoiceNumberPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Invoice>;
      })
    );
  }

  /**
   * Generate the Corona invoice number and payment reference.
   *
   * Mints the invoice's `new_number` — the deterministic
   * prefix·invoice-id·ordinal-`0` number document generation would mint
   * — together with the matching `new_reference_number`, built from the
   * invoice configuration's reference-number prefix and the Finnish
   * 7-3-1 check digit, and persists both. The write is conditional on
   * the number being absent, so concurrent calls mint at most once.
   *
   * The status code says what happened:
   *
   * - `201 Created` — this call minted the number; the body is the
   *   updated invoice.
   * - `200 OK` — the invoice already carried a `new_number` that
   *   decodes to its own id; nothing was written and the body is the
   *   unchanged invoice.
   *
   * Repeating the call therefore never renumbers the invoice, unlike
   * the legacy `PATCH /apiv2/invoices/{id}/generateInvoiceNumber`
   * action this replaces. To bump the ordinal on purpose, use
   * `POST /invoices/{id}/advance-invoice-number`.
   *
   * `error_code` values returned with `422`:
   *
   * - `missing_configuration` — the invoice has no `new_number` to
   *   return and no invoice configuration, so the reference-number
   *   prefix a mint would need is unknown. `message` tells the handler
   *   to assign a configuration first; this is the case the legacy
   *   action failed with a `500`. A configuration is only needed to
   *   mint: an invoice that already carries a `new_number` decoding to
   *   its own id answers `200 OK` whether or not it has one.
   * - `invoice_number_not_derivable` — the stored `new_number` does not
   *   decode to this invoice's id, i.e. it was hand-edited or
   *   imported. It is refused rather than silently overwritten; if that
   *   is really intended, change both `new_invoice_number` and
   *   `new_reference_number` through
   *   `PUT /invoices/{id}/information` — they are independent fields
   *   and neither is recomputed from the other.
   *
   * Requires the `invoice-docs:generate` permission (403 otherwise).
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `generateInvoiceNumber$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  generateInvoiceNumber(params: {
    id: number;
    context?: HttpContext
  }
): Observable<Invoice> {

    return this.generateInvoiceNumber$Response(params).pipe(
      map((r: StrictHttpResponse<Invoice>) => r.body as Invoice)
    );
  }

  /**
   * Path part for operation advanceInvoiceNumber
   */
  static readonly AdvanceInvoiceNumberPath = '/invoices/{id}/advance-invoice-number';

  /**
   * Advance the Corona invoice number to the next ordinal.
   *
   * Increments the ordinal (last) digit of the invoice's current
   * `new_number` and recomputes `new_reference_number` from the new
   * number and the invoice configuration's reference-number prefix, so
   * the two always stay the pair the minter would produce. Responds
   * `200 OK` with the updated invoice.
   *
   * This is the deliberate form of what the legacy
   * `PATCH /apiv2/invoices/{id}/generateInvoiceNumber` did on every
   * repeat click. Use it when a corrected invoice has to go out under a
   * new number: the documents already produced carry the old number, so
   * they must be regenerated and re-sent afterwards.
   *
   * The body's `reason` is required and explains why the invoice is
   * being renumbered. A successful advance leaves a priority comment on
   * the invoice, authored by the calling user, that records the
   * previous and new number, the previous and new reference and that
   * reason — the advance is rare and consequential, and this is what a
   * later reader of the invoice needs in order to understand it. The
   * comment is written in the same transaction as the number change, so
   * neither exists without the other.
   *
   * The write is conditional on the number the request read, so two
   * concurrent calls advance the ordinal exactly once and the loser
   * gets `409 Conflict` and leaves no comment.
   *
   * `error_code` values returned with `422`:
   *
   * - `reason_required` — the request carried no body, no `reason`, or
   *   a `reason` that is empty once surrounding whitespace is removed.
   *   Nothing is read or written; the refusal is the first thing the
   *   endpoint does.
   * - `invoice_number_missing` — the invoice has no `new_number` yet;
   *   call `POST /invoices/{id}/generate-invoice-number` first.
   * - `invoice_number_ordinal_exhausted` — the ordinal is already `9`,
   *   the highest the fixed-width number can carry.
   * - `invoice_number_not_derivable` — the stored `new_number` does not
   *   decode to this invoice's id, i.e. it was hand-edited or imported,
   *   so its ordinal is not ours to advance.
   * - `missing_configuration` — the invoice has no invoice
   *   configuration, so the new reference number cannot be built.
   *   `message` tells the handler to assign a configuration first.
   * - `invoice_sent_to_accounting` — the invoice carries an
   *   `external_id`, so it has already been sent to accounting
   *   (Netvisor). Incoming payments are matched by the invoice number
   *   accounting holds, so advancing now would leave every later
   *   payment unmatchable and the number is kept. There is no
   *   self-service alternative: `PUT /invoices/{id}/information`
   *   locks `new_invoice_number` and `new_reference_number` once the
   *   invoice is financed, and an invoice with an `external_id`
   *   necessarily is. Issuing a corrected document under a new number
   *   is an ops-level change.
   *
   * Requires the `invoice-docs:generate` permission (403 otherwise).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `advanceInvoiceNumber()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  advanceInvoiceNumber$Response(params: {
    id: number;
    context?: HttpContext
    body: AdvanceInvoiceNumberRequest
  }
): Observable<StrictHttpResponse<Invoice>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.AdvanceInvoiceNumberPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Invoice>;
      })
    );
  }

  /**
   * Advance the Corona invoice number to the next ordinal.
   *
   * Increments the ordinal (last) digit of the invoice's current
   * `new_number` and recomputes `new_reference_number` from the new
   * number and the invoice configuration's reference-number prefix, so
   * the two always stay the pair the minter would produce. Responds
   * `200 OK` with the updated invoice.
   *
   * This is the deliberate form of what the legacy
   * `PATCH /apiv2/invoices/{id}/generateInvoiceNumber` did on every
   * repeat click. Use it when a corrected invoice has to go out under a
   * new number: the documents already produced carry the old number, so
   * they must be regenerated and re-sent afterwards.
   *
   * The body's `reason` is required and explains why the invoice is
   * being renumbered. A successful advance leaves a priority comment on
   * the invoice, authored by the calling user, that records the
   * previous and new number, the previous and new reference and that
   * reason — the advance is rare and consequential, and this is what a
   * later reader of the invoice needs in order to understand it. The
   * comment is written in the same transaction as the number change, so
   * neither exists without the other.
   *
   * The write is conditional on the number the request read, so two
   * concurrent calls advance the ordinal exactly once and the loser
   * gets `409 Conflict` and leaves no comment.
   *
   * `error_code` values returned with `422`:
   *
   * - `reason_required` — the request carried no body, no `reason`, or
   *   a `reason` that is empty once surrounding whitespace is removed.
   *   Nothing is read or written; the refusal is the first thing the
   *   endpoint does.
   * - `invoice_number_missing` — the invoice has no `new_number` yet;
   *   call `POST /invoices/{id}/generate-invoice-number` first.
   * - `invoice_number_ordinal_exhausted` — the ordinal is already `9`,
   *   the highest the fixed-width number can carry.
   * - `invoice_number_not_derivable` — the stored `new_number` does not
   *   decode to this invoice's id, i.e. it was hand-edited or imported,
   *   so its ordinal is not ours to advance.
   * - `missing_configuration` — the invoice has no invoice
   *   configuration, so the new reference number cannot be built.
   *   `message` tells the handler to assign a configuration first.
   * - `invoice_sent_to_accounting` — the invoice carries an
   *   `external_id`, so it has already been sent to accounting
   *   (Netvisor). Incoming payments are matched by the invoice number
   *   accounting holds, so advancing now would leave every later
   *   payment unmatchable and the number is kept. There is no
   *   self-service alternative: `PUT /invoices/{id}/information`
   *   locks `new_invoice_number` and `new_reference_number` once the
   *   invoice is financed, and an invoice with an `external_id`
   *   necessarily is. Issuing a corrected document under a new number
   *   is an ops-level change.
   *
   * Requires the `invoice-docs:generate` permission (403 otherwise).
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `advanceInvoiceNumber$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  advanceInvoiceNumber(params: {
    id: number;
    context?: HttpContext
    body: AdvanceInvoiceNumberRequest
  }
): Observable<Invoice> {

    return this.advanceInvoiceNumber$Response(params).pipe(
      map((r: StrictHttpResponse<Invoice>) => r.body as Invoice)
    );
  }

  /**
   * Path part for operation sendInvoice
   */
  static readonly SendInvoicePath = '/invoices/{id}/send';

  /**
   * Send the invoice as a real verkkolasku via Apix.
   *
   * Starts SendInvoiceWorkflow: builds the per-mode image PDF, rebuilds
   * the Finvoice with the mode's `MessageReceiver` routing and the Apix
   * package link stanzas, stores the assembled zip as an
   * `ApixSendInvoiceZip` audit attachment, transmits it via the Apix
   * eInvoice transport, records the synchronous response in
   * `apix_einvoice_sends`, and finally advances the invoice state
   * (`WaitingForInvoiceToEndCustomer` → `MonitoringEndCustomerPayments`)
   * when the advance is enabled and the invoice is still in the
   * expected state.
   *
   * Two modes (see SendInvoiceRequestBody): `einvoice` routes to the
   * end customer's eInvoice address with the watermarked original
   * merged into the image; `paper` sends the Corona invoice only and
   * forces paper delivery (`TULOSTUS` / `N/A` routing).
   *
   * Requires the `invoice:send` permission (403 otherwise). Readiness
   * is validated synchronously and returns 422 with the full violation
   * list; an invoice outside `WaitingForInvoiceToEndCustomer` is a
   * violation unless `allow_in_unexpected_state` is set.
   *
   * ## Idempotency
   *
   * The workflow ID is stable per invoice (`send-invoice-<id>`,
   * regardless of mode), so a double-click — or a concurrent send in
   * the other mode — reuses the in-flight workflow and returns 202
   * with the existing workflow ID rather than transmitting twice.
   * Once the previous run reaches a terminal state, the same ID starts
   * a fresh send (Temporal's default AllowDuplicate policy).
   *
   * After a successful send is recorded, re-sending the invoice is an
   * `invoice_already_sent` violation (422) unless `allow_resend` is set
   * — a durable guard, independent of the state-advance kill-switch.
   * The same check runs again inside the workflow as a backstop, so a
   * send started by any path short-circuits without re-transmitting.
   *
   * ## eInvoice routing freshness guard
   *
   * For `einvoice`-mode sends whose stored routing is non-blank,
   * readiness additionally resolves the end customer's live Apix
   * routing (a bounded-timeout `addressquery`) and verifies the stored
   * `(address, operator)` is still registered. A stored routing absent
   * from the live results is a `stale_einvoice_address` violation
   * (422), clearable with `allow_stale_einvoice_address`. If the Apix
   * lookup is unreachable, errors, or times out, readiness fails closed
   * with a non-overridable `einvoice_address_unverifiable` violation
   * (422) — because a down `addressquery` almost certainly means the
   * send endpoint is down too, so the send is blocked rather than
   * attempted and left to fail. Paper mode clears routing and performs
   * no `addressquery` call; a blank-routing einvoice send reports only
   * `missing_end_customer_einvoice_routing` and makes no Apix call.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendInvoice()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendInvoice$Response(params: {
    id: number;
    context?: HttpContext
    body: SendInvoiceRequestBody
  }
): Observable<StrictHttpResponse<SendInvoiceAcceptedResult>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.SendInvoicePath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SendInvoiceAcceptedResult>;
      })
    );
  }

  /**
   * Send the invoice as a real verkkolasku via Apix.
   *
   * Starts SendInvoiceWorkflow: builds the per-mode image PDF, rebuilds
   * the Finvoice with the mode's `MessageReceiver` routing and the Apix
   * package link stanzas, stores the assembled zip as an
   * `ApixSendInvoiceZip` audit attachment, transmits it via the Apix
   * eInvoice transport, records the synchronous response in
   * `apix_einvoice_sends`, and finally advances the invoice state
   * (`WaitingForInvoiceToEndCustomer` → `MonitoringEndCustomerPayments`)
   * when the advance is enabled and the invoice is still in the
   * expected state.
   *
   * Two modes (see SendInvoiceRequestBody): `einvoice` routes to the
   * end customer's eInvoice address with the watermarked original
   * merged into the image; `paper` sends the Corona invoice only and
   * forces paper delivery (`TULOSTUS` / `N/A` routing).
   *
   * Requires the `invoice:send` permission (403 otherwise). Readiness
   * is validated synchronously and returns 422 with the full violation
   * list; an invoice outside `WaitingForInvoiceToEndCustomer` is a
   * violation unless `allow_in_unexpected_state` is set.
   *
   * ## Idempotency
   *
   * The workflow ID is stable per invoice (`send-invoice-<id>`,
   * regardless of mode), so a double-click — or a concurrent send in
   * the other mode — reuses the in-flight workflow and returns 202
   * with the existing workflow ID rather than transmitting twice.
   * Once the previous run reaches a terminal state, the same ID starts
   * a fresh send (Temporal's default AllowDuplicate policy).
   *
   * After a successful send is recorded, re-sending the invoice is an
   * `invoice_already_sent` violation (422) unless `allow_resend` is set
   * — a durable guard, independent of the state-advance kill-switch.
   * The same check runs again inside the workflow as a backstop, so a
   * send started by any path short-circuits without re-transmitting.
   *
   * ## eInvoice routing freshness guard
   *
   * For `einvoice`-mode sends whose stored routing is non-blank,
   * readiness additionally resolves the end customer's live Apix
   * routing (a bounded-timeout `addressquery`) and verifies the stored
   * `(address, operator)` is still registered. A stored routing absent
   * from the live results is a `stale_einvoice_address` violation
   * (422), clearable with `allow_stale_einvoice_address`. If the Apix
   * lookup is unreachable, errors, or times out, readiness fails closed
   * with a non-overridable `einvoice_address_unverifiable` violation
   * (422) — because a down `addressquery` almost certainly means the
   * send endpoint is down too, so the send is blocked rather than
   * attempted and left to fail. Paper mode clears routing and performs
   * no `addressquery` call; a blank-routing einvoice send reports only
   * `missing_end_customer_einvoice_routing` and makes no Apix call.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `sendInvoice$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendInvoice(params: {
    id: number;
    context?: HttpContext
    body: SendInvoiceRequestBody
  }
): Observable<SendInvoiceAcceptedResult> {

    return this.sendInvoice$Response(params).pipe(
      map((r: StrictHttpResponse<SendInvoiceAcceptedResult>) => r.body as SendInvoiceAcceptedResult)
    );
  }

  /**
   * Path part for operation sendSubfinancingInvoice
   */
  static readonly SendSubfinancingInvoicePath = '/invoices/{id}/send-subfinancing';

  /**
   * Send the subfinancing invoice to the invoice's subfinancing provider via Apix.
   *
   * Starts SendInvoiceWorkflow in `subfinancing` mode: regenerates the
   * invoice documents in `Subfinancing` generation mode, then transmits
   * the freshly rendered `Subfinancing Invoice` PDF **alone** — no
   * watermarked original merged in and no attachments archive — with the
   * Finvoice `MessageReceiver` set to the invoice configuration's
   * `subfinancing_einvoice_address` / `subfinancing_einvoice_operator`
   * while `BuyerParty` stays the end customer. The assembled zip is
   * stored as an `ApixSendInvoiceZip` audit attachment and every attempt
   * is recorded in `apix_einvoice_sends` with mode `subfinancing`.
   *
   * This is the automated form of the manual "Generate Subfinancing
   * Invoice → download → deliver by hand" flow, which is retained as the
   * backup. Requires the `invoice:send-subfinancing` permission (403
   * otherwise), distinct from `invoice:send`.
   *
   * **A subfinancing send never advances the invoice state**, regardless
   * of outcome or of the end-customer state-advance kill-switch.
   *
   * ## Invoice number
   *
   * The transmitted document carries the subfinancing generation mode's
   * invoice number — the invoice's `NewInvoiceNumber` suffixed with the
   * configuration's `PaymentTransferCode` (Lumi's is `L`, giving
   * `101139250L`). Apix's duplicate detection keys on
   * `<SellerBusinessID>_<InvoiceNumber>` and is receiver-independent, so
   * without the per-provider suffix this send and the end-customer send
   * of the same invoice would collide and whichever transmitted second
   * would be rejected as a duplicate. The reference number the payment
   * is matched on is unchanged.
   *
   * ## Readiness
   *
   * Readiness is validated synchronously and returns 422 with the full
   * violation list. It expects the invoice in `WaitingForFinancing` —
   * the provider is asked **before** the end-customer send, to learn
   * whether they will finance the invoice — overridable with
   * `allow_in_unexpected_state`. A missing finance date is **not** a
   * violation (the subfinancing mode substitutes the current date). A
   * configuration without subfinancing routing is
   * `missing_subfinancing_routing`; one without a `PaymentTransferCode`
   * is `missing_subfinancing_invoice_number_suffix`. The latter comes
   * from the same check
   * `/invoices/{id}/generate-subfinancing-invoice` runs, so both entry
   * points to the same document agree.
   *
   * An invoice on financing hold (a non-empty `financing_holds`) is
   * `financing_on_hold`, whose message names each applying hold's scope
   * and reason. Neither `allow_in_unexpected_state` nor `allow_resend`
   * overrides it: the send asks the provider to finance the invoice,
   * which is what the hold forbids.
   *
   * No end-customer eInvoice routing is required and **no Apix
   * `addressquery` freshness guard runs**: the receiver is our own
   * configured routing, not a registry lookup that can go stale.
   *
   * ## Idempotency
   *
   * The workflow ID is stable per invoice and distinct from the
   * end-customer send's (`send-subfinancing-invoice-<id>`), so a
   * double-click reuses the in-flight workflow while an end-customer
   * send of the same invoice can run independently. A delivered
   * subfinancing send (an `apix_einvoice_sends` row with mode
   * `subfinancing` and outcome `sent` or `duplicate`) makes a repeat an
   * `invoice_already_sent_to_subfinancing` violation unless
   * `allow_resend` is set. Prior `einvoice`/`paper` sends never block a
   * subfinancing send, and vice versa.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendSubfinancingInvoice()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendSubfinancingInvoice$Response(params: {
    id: number;
    context?: HttpContext
    body: SendSubfinancingInvoiceRequestBody
  }
): Observable<StrictHttpResponse<SendInvoiceAcceptedResult>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.SendSubfinancingInvoicePath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SendInvoiceAcceptedResult>;
      })
    );
  }

  /**
   * Send the subfinancing invoice to the invoice's subfinancing provider via Apix.
   *
   * Starts SendInvoiceWorkflow in `subfinancing` mode: regenerates the
   * invoice documents in `Subfinancing` generation mode, then transmits
   * the freshly rendered `Subfinancing Invoice` PDF **alone** — no
   * watermarked original merged in and no attachments archive — with the
   * Finvoice `MessageReceiver` set to the invoice configuration's
   * `subfinancing_einvoice_address` / `subfinancing_einvoice_operator`
   * while `BuyerParty` stays the end customer. The assembled zip is
   * stored as an `ApixSendInvoiceZip` audit attachment and every attempt
   * is recorded in `apix_einvoice_sends` with mode `subfinancing`.
   *
   * This is the automated form of the manual "Generate Subfinancing
   * Invoice → download → deliver by hand" flow, which is retained as the
   * backup. Requires the `invoice:send-subfinancing` permission (403
   * otherwise), distinct from `invoice:send`.
   *
   * **A subfinancing send never advances the invoice state**, regardless
   * of outcome or of the end-customer state-advance kill-switch.
   *
   * ## Invoice number
   *
   * The transmitted document carries the subfinancing generation mode's
   * invoice number — the invoice's `NewInvoiceNumber` suffixed with the
   * configuration's `PaymentTransferCode` (Lumi's is `L`, giving
   * `101139250L`). Apix's duplicate detection keys on
   * `<SellerBusinessID>_<InvoiceNumber>` and is receiver-independent, so
   * without the per-provider suffix this send and the end-customer send
   * of the same invoice would collide and whichever transmitted second
   * would be rejected as a duplicate. The reference number the payment
   * is matched on is unchanged.
   *
   * ## Readiness
   *
   * Readiness is validated synchronously and returns 422 with the full
   * violation list. It expects the invoice in `WaitingForFinancing` —
   * the provider is asked **before** the end-customer send, to learn
   * whether they will finance the invoice — overridable with
   * `allow_in_unexpected_state`. A missing finance date is **not** a
   * violation (the subfinancing mode substitutes the current date). A
   * configuration without subfinancing routing is
   * `missing_subfinancing_routing`; one without a `PaymentTransferCode`
   * is `missing_subfinancing_invoice_number_suffix`. The latter comes
   * from the same check
   * `/invoices/{id}/generate-subfinancing-invoice` runs, so both entry
   * points to the same document agree.
   *
   * An invoice on financing hold (a non-empty `financing_holds`) is
   * `financing_on_hold`, whose message names each applying hold's scope
   * and reason. Neither `allow_in_unexpected_state` nor `allow_resend`
   * overrides it: the send asks the provider to finance the invoice,
   * which is what the hold forbids.
   *
   * No end-customer eInvoice routing is required and **no Apix
   * `addressquery` freshness guard runs**: the receiver is our own
   * configured routing, not a registry lookup that can go stale.
   *
   * ## Idempotency
   *
   * The workflow ID is stable per invoice and distinct from the
   * end-customer send's (`send-subfinancing-invoice-<id>`), so a
   * double-click reuses the in-flight workflow while an end-customer
   * send of the same invoice can run independently. A delivered
   * subfinancing send (an `apix_einvoice_sends` row with mode
   * `subfinancing` and outcome `sent` or `duplicate`) makes a repeat an
   * `invoice_already_sent_to_subfinancing` violation unless
   * `allow_resend` is set. Prior `einvoice`/`paper` sends never block a
   * subfinancing send, and vice versa.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `sendSubfinancingInvoice$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendSubfinancingInvoice(params: {
    id: number;
    context?: HttpContext
    body: SendSubfinancingInvoiceRequestBody
  }
): Observable<SendInvoiceAcceptedResult> {

    return this.sendSubfinancingInvoice$Response(params).pipe(
      map((r: StrictHttpResponse<SendInvoiceAcceptedResult>) => r.body as SendInvoiceAcceptedResult)
    );
  }

  /**
   * Path part for operation listPaymentHistories
   */
  static readonly ListPaymentHistoriesPath = '/payment-histories';

  /**
   * List payment histories.
   *
   * Returns a paginated list of payment history records.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listPaymentHistories()` instead.
   *
   * This method doesn't expect any request body.
   */
  listPaymentHistories$Response(params?: {

    /**
     * Limit amount of returned results
     */
    limit?: number;

    /**
     * Cursor for the next page of results
     */
    after?: string;

    /**
     * Filter by Invoice ID
     */
    invoice_id?: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<PaymentHistoriesResponsePage>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.ListPaymentHistoriesPath, 'get');
    if (params) {
      rb.query('limit', params.limit, {});
      rb.query('after', params.after, {});
      rb.query('invoice_id', params.invoice_id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PaymentHistoriesResponsePage>;
      })
    );
  }

  /**
   * List payment histories.
   *
   * Returns a paginated list of payment history records.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `listPaymentHistories$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listPaymentHistories(params?: {

    /**
     * Limit amount of returned results
     */
    limit?: number;

    /**
     * Cursor for the next page of results
     */
    after?: string;

    /**
     * Filter by Invoice ID
     */
    invoice_id?: number;
    context?: HttpContext
  }
): Observable<PaymentHistoriesResponsePage> {

    return this.listPaymentHistories$Response(params).pipe(
      map((r: StrictHttpResponse<PaymentHistoriesResponsePage>) => r.body as PaymentHistoriesResponsePage)
    );
  }

  /**
   * Path part for operation listInvoiceConfigurations
   */
  static readonly ListInvoiceConfigurationsPath = '/invoice-configurations';

  /**
   * Get list of available invoice configurations.
   *
   * Get list of available invoice configurations
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listInvoiceConfigurations()` instead.
   *
   * This method doesn't expect any request body.
   */
  listInvoiceConfigurations$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<InvoiceConfiguration>>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.ListInvoiceConfigurationsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<InvoiceConfiguration>>;
      })
    );
  }

  /**
   * Get list of available invoice configurations.
   *
   * Get list of available invoice configurations
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `listInvoiceConfigurations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listInvoiceConfigurations(params?: {
    context?: HttpContext
  }
): Observable<Array<InvoiceConfiguration>> {

    return this.listInvoiceConfigurations$Response(params).pipe(
      map((r: StrictHttpResponse<Array<InvoiceConfiguration>>) => r.body as Array<InvoiceConfiguration>)
    );
  }

  /**
   * Path part for operation listInvoiceStates
   */
  static readonly ListInvoiceStatesPath = '/invoice-states';

  /**
   * Get list of available invoice states.
   *
   * Get list of available invoice states
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listInvoiceStates()` instead.
   *
   * This method doesn't expect any request body.
   */
  listInvoiceStates$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<InvoiceState>>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.ListInvoiceStatesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<InvoiceState>>;
      })
    );
  }

  /**
   * Get list of available invoice states.
   *
   * Get list of available invoice states
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `listInvoiceStates$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listInvoiceStates(params?: {
    context?: HttpContext
  }
): Observable<Array<InvoiceState>> {

    return this.listInvoiceStates$Response(params).pipe(
      map((r: StrictHttpResponse<Array<InvoiceState>>) => r.body as Array<InvoiceState>)
    );
  }

  /**
   * Path part for operation listInvoiceAttachmentTypes
   */
  static readonly ListInvoiceAttachmentTypesPath = '/invoice-attachment-types';

  /**
   * List available invoice attachment types.
   *
   * Returns all available attachment types. This is reference data that changes rarely.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listInvoiceAttachmentTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  listInvoiceAttachmentTypes$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<InvoiceAttachmentType>>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.ListInvoiceAttachmentTypesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<InvoiceAttachmentType>>;
      })
    );
  }

  /**
   * List available invoice attachment types.
   *
   * Returns all available attachment types. This is reference data that changes rarely.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `listInvoiceAttachmentTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listInvoiceAttachmentTypes(params?: {
    context?: HttpContext
  }
): Observable<Array<InvoiceAttachmentType>> {

    return this.listInvoiceAttachmentTypes$Response(params).pipe(
      map((r: StrictHttpResponse<Array<InvoiceAttachmentType>>) => r.body as Array<InvoiceAttachmentType>)
    );
  }

  /**
   * Path part for operation getEndCustomerInvoices
   */
  static readonly GetEndCustomerInvoicesPath = '/end-customers/{end_customer_id}/invoices';

  /**
   * Get invoices for an end customer.
   *
   * Get invoices for an end customer:w
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEndCustomerInvoices()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEndCustomerInvoices$Response(params: {
    end_customer_id: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<InvoicesResponsePage>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.GetEndCustomerInvoicesPath, 'get');
    if (params) {
      rb.path('end_customer_id', params.end_customer_id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InvoicesResponsePage>;
      })
    );
  }

  /**
   * Get invoices for an end customer.
   *
   * Get invoices for an end customer:w
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getEndCustomerInvoices$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEndCustomerInvoices(params: {
    end_customer_id: number;
    context?: HttpContext
  }
): Observable<InvoicesResponsePage> {

    return this.getEndCustomerInvoices$Response(params).pipe(
      map((r: StrictHttpResponse<InvoicesResponsePage>) => r.body as InvoicesResponsePage)
    );
  }

  /**
   * Path part for operation getClientInvoices
   */
  static readonly GetClientInvoicesPath = '/clients/{client_id}/invoices';

  /**
   * Get invoices for a client.
   *
   * Get invoices for a client
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getClientInvoices()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClientInvoices$Response(params: {
    client_id: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<InvoicesResponsePage>> {

    const rb = new RequestBuilder(this.rootUrl, InvoicesService.GetClientInvoicesPath, 'get');
    if (params) {
      rb.path('client_id', params.client_id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InvoicesResponsePage>;
      })
    );
  }

  /**
   * Get invoices for a client.
   *
   * Get invoices for a client
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getClientInvoices$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClientInvoices(params: {
    client_id: number;
    context?: HttpContext
  }
): Observable<InvoicesResponsePage> {

    return this.getClientInvoices$Response(params).pipe(
      map((r: StrictHttpResponse<InvoicesResponsePage>) => r.body as InvoicesResponsePage)
    );
  }

}
